import { WorkflowActiveModuleActionsPipe } from './../../../modules/shared/pipes/workflow-active-module-actions.pipe';
import { TimeZoneService } from './../../../modules/shared/services/timezone.service';
import { AccountModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, LeadModuleId, OpportunityModuleId, ProductModuleId,
    SOModuleId, VendorModuleId, LocationModuleId, TaskModuleId,
    PurchaseOrderModuleId,BillOrderModuleId,VendorReturnModuleId,VendorCreditModuleId,BillPaymentModuleId } from './../../../modules/shared/constants/modules.constant';
import { SharedChannelService } from './../../../modules/shared/services/channel.service';
import { Status } from './../../../modules/shared/models/status';
import { WorkflowActionModules, WorkflowMessages } from './../models/workflow.static';
import { ParseHelper } from './../../../modules/shared/parse.helper';
import { AccountService } from './../../../accounts/accountService';
import { ConfigurationService } from './../../../configurations/configurationService';
import { WorkflowModelsNS } from './../models/add-update-workflow.models';
import { User } from './../../../modules/shared/model/user.model';
import { AppMainService } from './../../../app-main.service';
import { AppMainComponent } from './../../../app.main.component';
import { UserService } from './../../../service/userservice';
import { FormErrorHandler } from './../../../modules/shared/helpers/form-error-handler.helper';
import { Component,  Input, OnInit, Output, OnDestroy, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from "moment";
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { SavedSearchNS } from '../../saved-searches/models/saved-search.models';
import { SavedSearchesService } from '../../saved-searches/services/saved-searches.service';
import { DataTypeWithOperatorNS, SavedSearchMessage } from '../../saved-searches/models/saved-search.static';
import { getSavedSearchRuleValues, getSavedSearchTreeRuleValues, savedSearchRuleNo } from '../../saved-searches/helpers/get-formated-rules-values.helper';
import { getSavedSearchTableColumns } from '../../saved-searches/helpers/get-saved-search-table-columns.helper';
import { prepareSavedSearchAddEditFilter } from '../../saved-searches/helpers/prepare-saved-searh-filter.helper';
import { prepareSavedSearchRuleValues } from '../../saved-searches/helpers/prepare-saved-search-rule-values.helper';
import { WorkflowService } from '../services/workflow.service';
import { Guid } from "guid-typescript";
import { convertToAbsolute } from '../../../modules/shared/validators/convert-to-absolute.validator';
import { convertToInteger } from '../../../modules/shared/validators/convert-to-integer.validator';
import { ObjectNames } from '../../../shared/constants';
import { PermissionService } from '../../../service/permission.service';
import { minMaxDateTimeValidator } from '../../../modules/shared/validators/min-max-datetime.validator';
import { makeDuplicateName } from '../../../modules/shared/helpers/make-duplicate-name.helper';
import { OrganizationSubscriptionService } from '../../../modules/shared/services/organization-subscription.service';
import { SubscriptionFeatureLimitM } from '../../../modules/shared/models/organization-subscription/subscription-feature-limit.modal';
import { FeatureSubscriptionInfoEnums } from '../../../modules/shared/enums/feature-subscription-info.enum';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-add-edit-workflow-dialog',
  templateUrl: './add-edit-workflow-dialog.component.html',
  styleUrls: ['./add-edit-workflow-dialog.component.scss'],
  providers: [WorkflowActiveModuleActionsPipe]
})
export class AddEditWorkflowDialogComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() displayAddEditDialog: boolean = false;
    @Input() workflowEditId: number = 0;
    @Input() workflowViewOnly: boolean = false;
    @Input() workflowCopy: boolean = false;
    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() loadNewList = new EventEmitter<boolean>();

    //logged user details
    loggedUserDetails: User;
    minimumDate = this.app._showDateTimeWithZone(new Date());


    //Workflow Edit
    workflowAddEditDialog: string = "Add New Workflow";
    workflowDetails: WorkflowModelsNS.WorkflowDetails;

    selectedEditedRule: SavedSearchNS.IRuleList = null;
    selectedRuleIndex: number = -1;
    displayEditRule: boolean = false;
    tempConditionGroup: WorkflowModelsNS.WorkflowAddedEditConditionGroup[] = [];


    //Workflow details form
    workflowDetailsForm: FormGroup = new FormGroup({});
    loadingWorkflowSave: boolean = false;
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();

    //Static Data
    workflowTypeList = [
        {id: WorkflowModelsNS.WorkflowTypeEnum.EVENT_BASED, name:"Event Based", message: "", allowBefore: false },
        {id: WorkflowModelsNS.WorkflowTypeEnum.TIME_DEPENDENT, name:"Time Based", message: "", allowBefore: false },
    ];

    criteriaList = [
        {id: WorkflowModelsNS.TriggerTypeEnum.CREATED, name:"Created", message: "", allowTimeDependent: true},
        {id: WorkflowModelsNS.TriggerTypeEnum.CREATED_EDITED, name:"Created, and everytime edited", message: "(Time Dependent workflow actions cannot be added with this option.)", allowTimeDependent: false},
        {id: WorkflowModelsNS.TriggerTypeEnum.CREATED_EDITED_CRITERIA, name:"Created, and everytime edited till it meets criteria", message: "", allowTimeDependent: true},
    ];

    steperMenu: MenuItem[] = [{label: 'Criteria'},{label: 'Conditions'}];
    steperActiveIndex: number = 0;

    accountChannelsFor: string[] = ['Estimate','Invoice','Opportunity','SalesOrder','PurchaseOrder'];
    associatedModuleFor: number[] = [AccountModuleId,LeadModuleId,VendorModuleId];
    choicesDD: SavedSearchNS.IChoice[] = [
        { id: 1, name: "And" },
        { id: 2, name: "Or" },
    ];
    //Dropdown list value
    users: any[] = [];
    activeUserTree: any[] = [];
    parentModules: SavedSearchNS.IObjectType[] = [];
    selectedModule: SavedSearchNS.IObjectType;
    parentModulesCopy: SavedSearchNS.IObjectType[] = [];
    parentTemplates: SavedSearchNS.ITemplate[] = [];
    selectedTemplate: SavedSearchNS.ITemplate;

    accountChannelsIsActive: any[] = [];
    accountChannels: any[] = [];

    assoModules: SavedSearchNS.IObjectType[] = [];
    selectedAssoModule: SavedSearchNS.IObjectType;
    assoTemplates: SavedSearchNS.ITemplate[] = [];
    selectedAssoTemplate: SavedSearchNS.ITemplate;
    availableFields: SavedSearchNS.IField[] = [];
    //Rules And Condtions
    ruleData: SavedSearchNS.IRuleList[] = [];
    ruleList: SavedSearchNS.IRuleList[] = [];
    mainLastRule: SavedSearchNS.IRuleList[] = [];
    tempLastRuleValues = {
        selectedFilter: null,
        selectedOperator: null,
        selectedValue: null,
        selectedValue2: null,
        selectedChoice: { id: 1, name: "And" },
        selectedDataTypeWithOperator: null,
        allEnumMultiselect: [],
        treeSelectData: [],
        selectedGroupLabel: "",
        selectedGroupChildren: "",
        selectedGroup: true,
        filtersDD: [],
        filtersDDTree: []
    };

    lastRuleValues = ParseHelper.DeepCopy(this.tempLastRuleValues);
    lastAssocRuleValues = ParseHelper.DeepCopy(this.tempLastRuleValues);
    assocRuleData: SavedSearchNS.IRuleList[] = [];
    assocRuleList: SavedSearchNS.IRuleList[] = [];

    conditionGroup: WorkflowModelsNS.WorkflowAddedEditConditionGroup[] = [];
    conditionTemp: WorkflowModelsNS.WorkflowAddedEditConditionGroup;
    actionType: 'instant'|'timedependent' = 'instant';
    timeDependentIndex: number;
    manualRuleIndex: number = 0;
    manualRuleHeader: 'Add Rule'|'Add Dependent Module' = "Add Rule";
    displayParentNewRule: boolean = false;

    //Saved Search Rules
    displaySavedSearchRule: boolean = false;
    displaySSPreviewDataList: boolean = false;
    ssPreviewDataList: any[] = []
    ssPreviewColumnList: SavedSearchNS.ISavedSearchPreviceColumnModel[] = [];

    //action data
    actionModules: any[] = WorkflowActionModules;
    selectedActionModule: any = null;

    accountModuleId = AccountModuleId;
    vendorModuleId = VendorModuleId;
    locationModuleId = LocationModuleId;
    taskModuleId = TaskModuleId;

    actionsDD = [
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.AddTask, name: "Add Task", code:"task", activeModules: [LeadModuleId,AccountModuleId,OpportunityModuleId] },
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.AddEmailAlert, name: "Add E-mail Alert", code:"email", activeModules: [
            LeadModuleId,AccountModuleId,OpportunityModuleId,VendorModuleId,
            TaskModuleId,LocationModuleId,ProductModuleId,InvoiceOrderModuleId,SOModuleId,EstimateOrderModuleId,
            PurchaseOrderModuleId,BillOrderModuleId,VendorReturnModuleId,VendorCreditModuleId,BillPaymentModuleId] },
        // { id: WorkflowModelsNS.WorkflowActionTypeEnum.AddWhatsAppAlert, name: "Add Whatsapp Alert", code:"whatsapp", activeModules: [LeadModuleId,AccountModuleId,OpportunityModuleId,ProductModuleId,InvoiceOrderModuleId,SOModuleId,EstimateOrderModuleId] },
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.UpdateField, name: "Update Field", code:"field", activeModules: [LeadModuleId,AccountModuleId,VendorModuleId,OpportunityModuleId,SOModuleId,InvoiceOrderModuleId,EstimateOrderModuleId,ProductModuleId]},
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.CreateRecord, name: "Create Record", code:"record", activeModules: [AccountModuleId,VendorModuleId]},
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.UpdateRecord, name: "Update Record", code:"updaterecord", activeModules: [InvoiceOrderModuleId,SOModuleId,EstimateOrderModuleId]},
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.Approval, name: "Add Approvals", code:"approvals", activeModules: [SOModuleId,EstimateOrderModuleId,InvoiceOrderModuleId] },
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.ConvertToInvoice, name: "Convert to Invoice", code:"convertToInvoice", activeModules: [SOModuleId,EstimateOrderModuleId]},
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.ConvertToInvoice, name: "Convert to Sales Order", code:"convertToSalesOrder", activeModules: [EstimateOrderModuleId]},
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.DeleteRecord, name: "Delete Records", code:"deleteRecords", activeModules: [LeadModuleId,AccountModuleId,OpportunityModuleId,VendorModuleId]},
        { id: WorkflowModelsNS.WorkflowActionTypeEnum.ItemReciept, name: "Item Receipt", code:"itemReceipt", activeModules: [PurchaseOrderModuleId]},
        // { id: WorkflowModelsNS.WorkflowActionTypeEnum.UpdateRecord1, name: "Update Record1", code:"updaterecord1", activeModules: [InvoiceOrderModuleId,SOModuleId,EstimateOrderModuleId]},
        // {id:4,name:"New Outbound Msg",code:"msg"},
    ];
    activeActionsDD = [];
    selectedAction: any = null;
    actionsData: any[] = [];
    workflowUpdateRecordOfferTypes = WorkflowModelsNS.WorkflowUpdateRecordOfferTypes;
    notificationType: number;
    notificationTypeEnum = WorkflowModelsNS.WorkflowNotificationTypeEnum;

    displayAddTask: boolean = false;
    displayAddEmailAlert: boolean = false;
    displayUpdateField: boolean = false;
    displayNewMsg: boolean = false;
    displayAddApproval: boolean = false;
    displayCreateRecord: boolean = false;
    displayUpdateRecord: boolean = false;
    displayDeleteRecord: boolean = false;
    displayUpdateRecord1: boolean = false;
    fromUpdateRecord: boolean = false;


    //Edit action data
    selectedActionTask: WorkflowModelsNS.WorkflowAddEditActionTask = null;
    selectedTaskIndex: number = -1;

    selectedActionEmail: WorkflowModelsNS.WorkflowAddEditActionEmail = null;
    selectedEmailIndex: number = -1;

    selectedActionField: any = null;
    selectedFieldIndex: number = -1;

    selectedActionRecord: WorkflowModelsNS.WorkflowAddEditActionCreateRecord = null;
    selectedRecordIndex: number = -1;

    selectedActionUpdateRecord: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord = null;
    selectedUpdateRecordIndex: number = -1;

    deleteRecordStatusNames: string[] = ['','Active','In Active','Delete'];
    deleteRecordsStatusList: {id: number, name: string}[] = [
        {id: Status.Active, name: 'Active'},
        {id: Status.InActive, name: 'In Active'},
        {id: Status.Deleted, name: 'Delete'},
    ];
    selectedDeleteRecordStatus: number = null;
    selectedActionDeleteRecord: WorkflowModelsNS.WorkflowAddEditActionDeleteRecords = null;
    selectedDeleteRecordIndex: number = -1;

    selectedActionApprovals: WorkflowModelsNS.WorkflowAddEditActionApprovals[] = [];

    //Trigger Action Data
    triggerTimeHeader: string = "Add trigger time";
    displayAddTriggerTime: boolean = false;

    startBaseFields = [
        {
            name: 'Execution Date',
            fieldName: 'ExecutionDateTime'
        }
    ];

    addOrSubstractBases = [
        { id: 2, name:"After" },
        { id: 1, name:"Before" },
    ];

    occurrenceBases = [
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Years, name:"Years" },
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Months, name:"Months" },
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Days, name:"Days" },
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Hours, name:"Hours" },
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Minutes, name:"Minutes" },
    ];

    scheduleOccurrenceTypes = [
        { id: WorkflowModelsNS.WorkflowScheduleTypesEnum.Once, name:"Once" },
        { id: WorkflowModelsNS.WorkflowScheduleTypesEnum.Recurring, name:"Recurring" }
    ];

    scheduleTypesEnum = WorkflowModelsNS.WorkflowScheduleTypesEnum;

    allOccurrenceBases = [
        ...this.occurrenceBases,
        { id: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Seconds, name:"Seconds" }
    ];

    occurrenceValues: number[] = [];

    //Edit Trigger Data
    selectedTriggerTime: WorkflowModelsNS.WorkflowTimeDependentActions = null;

    taskSchedulerSubmitLoading: boolean = false;
    workflowValidExpired: boolean = false;
    workflowValidExpiredText: string = "";

    //Fields List
    addedFields: string[] = [];
    workflowExecutionStatus = WorkflowModelsNS.WorkflowExecutionStatus;
    wareHouseLocationList:any[] = [];

    subscriptionLimit: SubscriptionFeatureLimitM = null;
    workflowConversionTypeNames = WorkflowModelsNS.WorkflowConversionTypeNames;

    constructor(
        public app: AppMainComponent,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private formBuilder: FormBuilder,
        private appMainService: AppMainService,
        private userService: UserService,
        private savedSearchesService: SavedSearchesService,
        private configService: ConfigurationService,
        private accountService: AccountService,
        private workflowService: WorkflowService,
        private sharedChannelService: SharedChannelService,
        private permissionService: PermissionService,
        private timezoneService: TimeZoneService,
        private organizationSubscriptionService: OrganizationSubscriptionService,
        private workflowActiveModuleActionsPipe: WorkflowActiveModuleActionsPipe
    ) {
        this.loggedUserDetails = this.app.user;
    }

    ngOnInit(): void {
        this.checkSubscriptionLimit();
        this.initWorkflowDetailsForm();
        this.getUsers();
        this.getUserTree();
        this.getModuleDetails();
        this.getAccountChannels();
        this.getAllWarehouse();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['displayAddEditDialog'] && changes['displayAddEditDialog'].currentValue){
            this.displayAddEditDialog = changes['displayAddEditDialog'].currentValue;
        }

        if(changes['workflowViewOnly'] && changes['workflowViewOnly'].currentValue){
            this.workflowViewOnly = changes['workflowViewOnly'].currentValue;
        }

        if(changes['workflowEditId'] && changes['workflowEditId'].currentValue){
            this.workflowEditId = changes['workflowEditId'].currentValue;
            this.loadWorkflowDetails(this.workflowEditId)
        }
    }

    checkSubscriptionLimit(){
        this.appMainService.isShowSpinner('checkSubscriptionLimit');
        this.organizationSubscriptionService
        .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Workflow)
        .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.subscriptionLimit = response;
                this.appMainService.isHideSpinner('checkSubscriptionLimit');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('checkSubscriptionLimit');
            }
        })
    }

    get subscriptionLimitReached(){
        return (((!this.workflowDetailsForm.getRawValue().id
        && !this.workflowEditId) || this.workflowCopy)
        && this.subscriptionLimit?.allowedLicence
        && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
    }

    initWorkflowDetailsForm(){
        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        this.minimumDate = this.app._showDateTimeWithZone(new Date());
        this.workflowDetailsForm = this.formBuilder.group({
            id: [0],
            organizationId: [this.loggedUserDetails.organizationId],
            occurrenceBase: [this.occurrenceBases[4]],
            occurrenceType: [this.scheduleTypesEnum.Once],
            occurrenceValue: [5, [convertToAbsolute, convertToInteger]],
            sequenceNumber: [""],
            name: ["",{
                validators: [Validators.required, Validators.minLength(3), Validators.maxLength(255)],
                asyncValidators: [this.workflowExistValidator()],
                updateOn: 'blur'
            }],
            selectedUsers: [null, [Validators.required]],
            selectedModule: [null, [Validators.required]],
            selectedChannel: [null, [Validators.required]],
            wareHouseLocationId: [null],
            selectedAccountChannel: [null],
            description: [""],
            scheduledDate: [this.minimumDate],
            validFromDate: [this.minimumDate, [Validators.required]],
            validToDate: [null],
            isActive: [true],
            workflowType: [{value: this.workflowTypeList[0], disabled: (this.workflowViewOnly || (this.workflowEditId && !this.workflowCopy))}, [Validators.required]],
            selectedTriggerType: [this.criteriaList[0], [Validators.required]],
            executionStatus: [WorkflowModelsNS.WorkflowExecutionStatus.Pending]
        });

        if(this.workflowViewOnly){
            this.workflowDetailsForm.disable();
        }

        this.selectOccurenceBase();

        this.formErrorHandler.handleErrors(this.workflowDetailsForm, this.detailsFormErrors, {
            name: {
            required: "Enter workflow name",
            minlength: "Enter more than 3 characters",
            maxlength: "Enter less than 255 characters",
            workflowExists: "Workflow already added with this name!"
          },
          selectedUsers: {
            required: "Select any users",
          },
          selectedModule: {
            required: "Select any module",
          },
          selectedChannel: {
            required: "Select any channel",
          },
          selectedAccountChannel: {
            required: "Select any account channel",
          },
          selectedTriggerType: {
            required: "Select any evaluate criteria",
          },
          validFromDate: {
            required: "Select any start date",
          },
          validToDate: {
            required: "Select any end date",
          },
          scheduledDate: {
            required: "Select workflow schedule date",
            minDate: "Schedule date can't be a past date"
          },
          wareHouseLocationId: {
            required: "Select any warehouse location",
          },
        });

        this.workflowDetailsForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(e => this.isUnsavedData = true);

        this.workflowDetailsForm.get('workflowType').valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(value=>{
            if(value.id===WorkflowModelsNS.WorkflowTypeEnum.TIME_DEPENDENT){
                this.workflowDetailsForm.patchValue({
                    selectedTriggerType: this.criteriaList[0]
                })
            }
        });

        this.workflowDetailsForm.get('occurrenceType').valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(value=>{
            if(value==this.scheduleTypesEnum.Once){
                const validFromDate = this.app._showDateTimeWithZone(new Date());
                this.workflowDetailsForm.patchValue({
                    validFromDate: validFromDate,
                    validToDate: null
                })
            }
        })
    }

    validateScheduleDate(){
        const control = this.workflowDetailsForm.get('scheduledDate');

        if(control){
            control.setValidators([]);
            control.updateValueAndValidity();
        }

        if(this.workflowDetailsForm.getRawValue().workflowType?.id==2 && this.workflowDetailsForm.getRawValue().occurrenceType==this.scheduleTypesEnum.Once){
            if(control){
                const minDate = this.workflowDetailsForm.getRawValue().validFromDate ? new Date(this.workflowDetailsForm.getRawValue().validFromDate) : null;
                // const maxDate = this.workflowDetailsForm.getRawValue().validToDate ? new Date(this.workflowDetailsForm.getRawValue().validToDate) : null;
                control.setValidators([Validators.required, minMaxDateTimeValidator(minDate, null)]);
                control.updateValueAndValidity();
            }
        }else{
            if(control){
                control.setValidators([]);
                control.updateValueAndValidity();
            }
        }
    }

    nextStep(step) {
        if(!this.workflowViewOnly){
            this.validateScheduleDate();
            if (this.workflowDetailsForm.invalid) {
                this.formErrorHandler.showErrorOnSubmit();
                this.scrollToError();
                return; //Return if form invalid
            }
        }

        var arr = document.getElementsByClassName("p-steps-item");
        for (let i in this.steperMenu) {
            if (i < step + 1) {
                arr[i].classList.add("activeItem");
            }
        }
        this.steperActiveIndex = this.steperActiveIndex + 1;
    }

    backStep(step) {
        var arr = document.getElementsByClassName("p-steps-item");
        for (let i in this.steperMenu) {
            if (i >= step) {
                arr[i].classList.remove("activeItem");
            }
        }
        this.steperActiveIndex = this.steperActiveIndex - 1;
    }

    //#region ***Edit Methods***

    loadWorkflowDetails(workflowId: number){
        this.appMainService.isShowSpinner('LoadWorkflowDetails');
        this.workflowService.getWorkflowById(workflowId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.appMainService.isHideSpinner('LoadWorkflowDetails');
                this.workflowDetails = response;
                this.setWorkflowEditDetails();
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('LoadWorkflowDetails');
                this.messageService.add({ severity: WorkflowMessages.error.toLowerCase(), summary: WorkflowMessages.error, detail: WorkflowMessages.detailsErrorMsg });

                setTimeout(()=>{
                    this.dialogClosed.emit(true);
                },500);

            },
            complete: ()=> {

            }
        })
    }

    setWorkflowEditDetails(){
        this.workflowAddEditDialog = this.workflowCopy ? "Copy Workflow" : "Edit Workflow";
        const selectedTriggerType = this.criteriaList.find(c=> c.id===this.workflowDetails.triggerType)||this.criteriaList[0];
        const occurrenceBase = this.occurrenceBases.find(c=>c.id===this.workflowDetails.occurrenceBase)||this.occurrenceBases[4]
        const workflowType = this.workflowDetails.triggerType==WorkflowModelsNS.TriggerTypeEnum.TIME_DEPENDENT ? WorkflowModelsNS.WorkflowTypeEnum.TIME_DEPENDENT : WorkflowModelsNS.WorkflowTypeEnum.EVENT_BASED;
        const selectedWorkflowType = this.workflowTypeList.find(c=>c.id==workflowType);

        let startDate = this.workflowDetails.validFromDate ?  this.app._showDateTimeWithZone(this.workflowDetails.validFromDate) : null;
        let endDate = this.workflowDetails.validToDate ?  this.app._showDateTimeWithZone(this.workflowDetails.validToDate) : null;
        const scheduledDate = this.workflowDetails.scheduledDate ?  this.app._showDateTimeWithZone(this.workflowDetails.scheduledDate) : null;

        let occurrenceType = this.workflowDetails.occurrenceType;

        if(!occurrenceType && workflowType==WorkflowModelsNS.WorkflowTypeEnum.TIME_DEPENDENT){
            occurrenceType = this.scheduleTypesEnum.Recurring;
        }

        if(occurrenceType==this.scheduleTypesEnum.Once){
            startDate = this.app._showDateTimeWithZone(new Date());
            endDate = null;
        }

        let workflowName: string = this.workflowDetails.name;

        if(this.workflowCopy){
            workflowName = makeDuplicateName(workflowName);
        }

        this.workflowDetailsForm.patchValue({
            id: this.workflowCopy ? 0 : this.workflowDetails.id,
            organizationId: this.workflowDetails.organizationId,
            occurrenceType: occurrenceType,
            occurrenceBase: occurrenceBase,
            occurrenceValue: this.workflowDetails.occurrenceValue||5,
            sequenceNumber: this.workflowCopy ? "" : this.workflowDetails.sequenceNumber,
            name: workflowName,
            description: this.workflowDetails.description,
            scheduledDate: scheduledDate,
            validFromDate: startDate,
            validToDate: endDate,
            isActive: (this.workflowDetails.statusId==Status.Active || this.workflowCopy)? true : false,
            selectedTriggerType: selectedTriggerType,
            workflowType: selectedWorkflowType,
            executionStatus: this.workflowCopy ? WorkflowModelsNS.WorkflowExecutionStatus.Pending : this.workflowDetails.executionStatus||WorkflowModelsNS.WorkflowExecutionStatus.Pending,
            selectedAccountChannel: this.workflowDetails.accountChannelId ? this.accountChannelsIsActive.find(c => c.id == this.workflowDetails.accountChannelId) : null,
            wareHouseLocationId: this.workflowDetails?.accountChannelId||null,
        });

        this.checkWorkflowValidDate();
        if(this.activeUserTree.length>0){
            this.setSelectedUsers();
        }

        this.selectOccurenceBase();
        const nameCtrl = this.workflowDetailsForm.get('name');

        if(this.workflowViewOnly){
            nameCtrl.disable();
        }else{
            nameCtrl.enable();
        }

        if(this.parentModules.length>0){
            const selectedModule = this.parentModules.find(moduleDetails=> moduleDetails.objectId===this.workflowDetails.objectId);

            if(selectedModule){
                this.workflowDetailsForm.patchValue({
                    selectedModule: selectedModule
                },{onlySelf: true, emitEvent: false});

                this.selectParentModule();
            }
        }

        // if(this.accountChannelsIsActive.length>0){
        //     const selectedAccountChannel = this.accountChannelsIsActive.find(channel=> channel.id===this.workflowDetails.accountChannelId);

        //     if(selectedAccountChannel){
        //         this.workflowDetailsForm.patchValue({
        //             selectedAccountChannel: selectedAccountChannel
        //         },{onlySelf: true, emitEvent: false});
        //     }
        // }

        this.conditionGroup = [];
        this.workflowDetails.workflowConditions.filter(c=>c.statusId==Status.Active).sort((a, b)=> b.order - a.order).map(addedCondition=>{

            const constionRefId: number = this.conditionGroup.length>0 ? this.conditionGroup[0].id + 1 : 1;
            const addedInstantAction = addedCondition?.workflowActions.find(actionDetails=>actionDetails.occurrenceType===WorkflowModelsNS.OccurrenceTypeEnum.INSTANT && actionDetails.statusId==Status.Active);
            const conditionData: WorkflowModelsNS.WorkflowAddedEditConditionGroup = {
                id: constionRefId,
                conditionId: addedCondition.id,
                statusId: addedCondition?.statusId||1,
                type: addedCondition.isMannualCondition ? 'manual' : 'savedsearch',
                savedSearchId: addedCondition.saveSearchId,
                isCombinational: addedCondition?.savedSearchInfo?.isCombinational||false,
                ruleCombination: addedCondition?.savedSearchInfo?.ruleCombination||"",
                validData: true,
                errorMsg: "",
                ruleData: [],
                instantActions: {
                    ...addedInstantAction,
                    executionOrders: ParseHelper.DeepCopy(WorkflowModelsNS.WorkflowActionDefaultOrders),
                    workflowActionTasks: [],
                    workflowActionEmails: [],
                    workflowActionUpdateFields: [],
                    workflowActionCreateRecords: [],
                    workflowActionUpdateRecords: [],
                    workflowActionConvertToInvoices: [],
                    workflowActionDeleteRecords: [],
                    workflowActionApprovals: []
                },
                timeDependentActions: []
            }

            if(this.workflowCopy){
                conditionData.conditionId = 0;
                conditionData.type = 'manual';
                conditionData.savedSearchId = 0;
            }

            addedCondition.workflowActions.filter(actionDetails=>actionDetails.statusId==Status.Active).map((actionDetails)=>{

                if(actionDetails?.workflowActionTasks){
                    actionDetails.workflowActionTasks = actionDetails.workflowActionTasks.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionEmails){
                    actionDetails.workflowActionEmails = actionDetails.workflowActionEmails.filter(email=> email.statusId==Status.Active)||[];

                    actionDetails.workflowActionEmails.map(emailDetails=>{

                        if(emailDetails.workflowEmailAttachments?.length>0){
                            const addedAttachments: WorkflowModelsNS.EmailTemplateAttachments[] = [];
                            emailDetails.workflowEmailAttachments.map(attachmentDetails=>{
                                attachmentDetails = {
                                    ...attachmentDetails,
                                    oldAttachment: attachmentDetails.attachment,
                                    attachment: null,
                                }

                                addedAttachments.push(attachmentDetails);
                            })

                            emailDetails.workflowEmailAttachments = addedAttachments;
                        }

                    })
                }

                if(actionDetails?.workflowActionUpdateFields){
                    actionDetails.workflowActionUpdateFields = actionDetails.workflowActionUpdateFields.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionCreateRecords){
                    actionDetails.workflowActionCreateRecords = actionDetails.workflowActionCreateRecords.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionApprovals){
                    actionDetails.workflowActionApprovals = actionDetails.workflowActionApprovals.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionUpdateRecords){
                    actionDetails.workflowActionUpdateRecords = actionDetails.workflowActionUpdateRecords.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionConvertToInvoices){
                    actionDetails.workflowActionConvertToInvoices = actionDetails.workflowActionConvertToInvoices.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionDeleteRecords){
                    actionDetails.workflowActionDeleteRecords = actionDetails.workflowActionDeleteRecords.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails.occurrenceType===WorkflowModelsNS.OccurrenceTypeEnum.INSTANT){
                    if(actionDetails?.workflowActionTasks?.length>0)
                    conditionData.instantActions.workflowActionTasks = [...conditionData.instantActions.workflowActionTasks,...actionDetails.workflowActionTasks];

                    if(actionDetails?.workflowActionEmails?.length>0)
                    conditionData.instantActions.workflowActionEmails = [...conditionData.instantActions.workflowActionEmails,...actionDetails.workflowActionEmails];

                    if(actionDetails?.workflowActionUpdateFields?.length>0)
                    conditionData.instantActions.workflowActionUpdateFields = [...conditionData.instantActions.workflowActionUpdateFields,...actionDetails.workflowActionUpdateFields];

                    if(actionDetails?.workflowActionCreateRecords?.length>0)
                    conditionData.instantActions.workflowActionCreateRecords = [...conditionData.instantActions.workflowActionCreateRecords,...actionDetails.workflowActionCreateRecords];

                    if(actionDetails?.workflowActionApprovals?.length>0)
                    conditionData.instantActions.workflowActionApprovals = [...conditionData.instantActions.workflowActionApprovals,...actionDetails.workflowActionApprovals];

                    if(actionDetails?.workflowActionUpdateRecords?.length>0)
                    conditionData.instantActions.workflowActionUpdateRecords = [...conditionData.instantActions.workflowActionUpdateRecords,...actionDetails.workflowActionUpdateRecords];

                    if(actionDetails?.workflowActionConvertToInvoices?.length>0)
                    conditionData.instantActions.workflowActionConvertToInvoices = [...conditionData.instantActions.workflowActionConvertToInvoices,...actionDetails.workflowActionConvertToInvoices];

                    if(actionDetails?.workflowActionDeleteRecords?.length>0)
                        conditionData.instantActions.workflowActionDeleteRecords = [...conditionData.instantActions.workflowActionDeleteRecords,...actionDetails.workflowActionDeleteRecords];
                }else{
                    const action: any = actionDetails;
                    const startDateBaseField = this.startBaseFields[0];
                    const occurrenceBase = this.allOccurrenceBases.find(c=>c.id===actionDetails.occurrenceBase)||this.occurrenceBases[2];
                    const selectedAddOrSubstractBase = actionDetails.occurrenceValue>=0 ? this.addOrSubstractBases[0] : this.addOrSubstractBases[1];
                    actionDetails.occurrenceValue = Math.abs(actionDetails.occurrenceValue);

                    conditionData.timeDependentActions.push({
                        ...action,
                        executionOrders: ParseHelper.DeepCopy(WorkflowModelsNS.WorkflowActionDefaultOrders),
                        addOrSubstractBase: selectedAddOrSubstractBase.id,
                        addOrSubstractBaseName: selectedAddOrSubstractBase.name,
                        occurrenceBaseName: occurrenceBase?.name,
                        dateTimeFieldLabel: startDateBaseField.name,
                    });
                }
            })
            conditionData.ruleData = [];
            addedCondition.savedSearchInfo.savedSearchRule.map((rule: any)=>{
                let choice = this.choicesDD.find(x => x.name == rule.operator);
                let ruleNo = rule?.ruleNo ? rule?.ruleNo : savedSearchRuleNo([...this.ruleData,...addedCondition.savedSearchInfo.savedSearchRule] as any[]);
                let eachRule: SavedSearchNS.IRuleList = {
                    id: this.workflowCopy ? 0 : rule.id,
                    ruleNo: ruleNo,
                    module: this.getModuleAddEdit(rule),
                    subModule: this.selectedAssoModule,
                    template: { id: rule.templateId, templateName: rule.templateName, objectId: rule.objectId, channelId: 0, channelName: '', isActive: true },
                    filter: prepareSavedSearchAddEditFilter(rule),
                    operator: { id: 1, name: rule.equation },
                    value: rule.values,
                    value2: null,
                    choice: choice,
                    isMainModule: rule.isMainModule,
                    dataTypeWithOperator: this.getOperatorByDataTypeAddEdit(rule.dataType, rule.equation),
                    valueLists: [],
                    treeValueLists: [],
                    objectId: rule.objectId,
                    objectName: rule.objectName,
                    valueRefId: rule.valueRefId,
                    groupLabel: "",
                    groupChildren: "",
                    group: false,
                    filtersDD: [],
                    filtersDDTree: [],
                    canEdit: true,
                    accountChannel: this.workflowDetailsForm.getRawValue().selectedAccountChannel,
                    compareWithField: rule?.compareWithField||false,
                    comparisonCriteria: rule?.comparisonCriteria||null,
                    comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                    comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                    isCustomComparisonCriteria: rule?.isCustomComparisonCriteria||false,
                    comparisonCriteriaObject: rule?.comparisonCriteriaObject||null,
                    customAttributeObjectId: rule?.customAttributeObjectId||null,
                    comparisonCustomAttributeObjectId: rule?.comparisonCustomAttributeObjectId||null,
                };
                //****Prepare Value
                // console.log(eachRule)
                const { value, value2 } = prepareSavedSearchRuleValues(eachRule, this.app.usersList);
                eachRule.value = value;
                eachRule.value2 = value2;
                conditionData.ruleData.push(eachRule);
            });

            this.setCanEdit(conditionData.ruleData);

            conditionData.instantActions.executionOrders.map(actionOrder=>{
                if(conditionData.instantActions?.[actionOrder.code]?.length>0){
                    actionOrder.executionOrder = conditionData.instantActions?.[actionOrder.code][0].executionOrder||0;
                }
            });
            conditionData.instantActions.executionOrders = conditionData.instantActions.executionOrders.sort((a,b)=> a.executionOrder - b.executionOrder);
            this.reOrderActions(conditionData.instantActions);

            conditionData.timeDependentActions.map(timeDependentAction=>{
                timeDependentAction.executionOrders.map(actionOrder=>{
                    if(timeDependentAction?.[actionOrder.code]?.length>0){
                        actionOrder.executionOrder = timeDependentAction?.[actionOrder.code][0].executionOrder||0;
                    }
                });
                timeDependentAction.executionOrders = timeDependentAction.executionOrders.sort((a,b)=> a.executionOrder - b.executionOrder);
                this.reOrderActions(timeDependentAction);
            });

            if(this.conditionGroup.length>0){
                this.conditionGroup.unshift(conditionData)
            }else{
                this.conditionGroup.push(conditionData)
            }


        })

        this.tempConditionGroup =  ParseHelper.DeepCopy(this.conditionGroup);
    }

    getModuleAddEdit(rule: SavedSearchNS.SavedSearchRuleRequest): SavedSearchNS.IObjectType {
        let parentModule: SavedSearchNS.IObjectType;
        if (rule.isMainModule) {
            parentModule = (this.parentModules.find(x => x.objectId == rule.objectId)||{
                objectId: rule?.objectId,
                name: rule?.objectName
            }) as any;
        }
        else {
            parentModule = (this.assoTemplates?.find(x => x.objectId == rule.objectId)||{
                objectId: rule?.objectId,
                name: rule?.objectName
            }) as any;


        }
        return parentModule;
    }

    getOperatorByDataTypeAddEdit(dataType: string, operator: string): DataTypeWithOperatorNS.ISavedSearchDataTypeWithOperator {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == dataType && x.Operator == operator);
        return selectedDataTypeAndOperator;
    }

    //#endregion

    //#region ***Save Methods***

    saveWorkflow(){
        if (this.workflowDetailsForm.invalid) {
            this.backStep(this.steperActiveIndex);
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        if(!this.validateRuleError()){
            return;
        }
        this.validateCondtions(true);
        const invalidCondtions = this.conditionGroup.filter(addedCondition=> !addedCondition.validData);
        if(this.conditionGroup.length==0 || invalidCondtions.length>0){
            this.scrollToError();
            return;
        }

        this.loadingWorkflowSave = true;

        let triggerType = this.workflowDetailsForm.getRawValue().selectedTriggerType.id;
        let occurrenceBase = this.occurrenceBases[4].id; //Minutes
        let occurrenceValue = 1;
        let occurrenceType: WorkflowModelsNS.WorkflowScheduleTypesEnum = WorkflowModelsNS.WorkflowScheduleTypesEnum.Recurring;

        if(this.workflowDetailsForm.getRawValue().workflowType.id===WorkflowModelsNS.WorkflowTypeEnum.TIME_DEPENDENT){
            triggerType = WorkflowModelsNS.TriggerTypeEnum.TIME_DEPENDENT;
            occurrenceBase = this.workflowDetailsForm.getRawValue().occurrenceBase?.id||5;
            occurrenceValue = this.workflowDetailsForm.getRawValue().occurrenceValue||1;
            occurrenceType = this.workflowDetailsForm.getRawValue().occurrenceType;
        }

        const startDate = this.workflowDetailsForm.getRawValue().validFromDate ?  this.timezoneService.saveDateTimeWithZone(this.workflowDetailsForm.getRawValue().validFromDate).toISOString() : null;
        let endDate = this.workflowDetailsForm.getRawValue().validToDate ?  this.timezoneService.saveDateTimeWithZone(this.workflowDetailsForm.getRawValue().validToDate).toISOString() : null;
        const scheduledDate = this.workflowDetailsForm.getRawValue().scheduledDate ?  this.timezoneService.saveDateTimeWithZone(this.workflowDetailsForm.getRawValue().scheduledDate).toISOString() : null;

        if(occurrenceType==this.scheduleTypesEnum.Once && scheduledDate){
            endDate = scheduledDate;
        }

        if(this.workflowCopy){
            this.workflowDetails = null;
        }

        let accountChannelId = this.workflowDetailsForm.getRawValue().selectedAccountChannel?.id;
        let accountChannelName = this.workflowDetailsForm.getRawValue().selectedAccountChannel?.name;

        if(this.workflowDetailsForm.getRawValue().selectedModule.name == 'Product'){
            const warehouseDetails = this.wareHouseLocationList.find(warehouse=> warehouse.id==this.workflowDetailsForm.getRawValue().wareHouseLocationId);
            accountChannelId = this.workflowDetailsForm.getRawValue().wareHouseLocationId || 0;
            accountChannelName = warehouseDetails?.name||"";
        }

        const workflowData: WorkflowModelsNS.WorkflowAddEditDetails = {
            id: this.workflowDetailsForm.getRawValue().id,
            organizationId: this.app.user.organizationId,
            sequenceNumber: this.workflowDetailsForm.getRawValue().sequenceNumber || null,
            name: this.workflowDetailsForm.getRawValue().name,
            objectId: this.workflowDetailsForm.getRawValue().selectedModule.objectId,
            objectName: this.workflowDetailsForm.getRawValue().selectedModule.name,
            channelId: this.workflowDetailsForm.getRawValue().selectedChannel?.channelId,
            channelName: this.workflowDetailsForm.getRawValue().selectedChannel?.channelName,
            description: this.workflowDetailsForm.getRawValue().description || "",
            triggerType: triggerType,
            occurrenceType: occurrenceType,
            occurrenceBase: occurrenceBase,
            occurrenceValue: occurrenceValue,
            statusId: this.workflowDetailsForm.getRawValue().isActive ? 1 : 2,
            executionStatus: this.workflowDetailsForm.getRawValue().executionStatus || WorkflowModelsNS.WorkflowExecutionStatus.Pending,
            validFromDate: startDate,
            validToDate: endDate,
            scheduledDate: scheduledDate,
            jobId: this.workflowDetails?.jobId || null,
            lastEndDate: this.workflowDetails?.lastEndDate || null,
            lastStartDate: this.workflowDetails?.lastStartDate || null,
            lastSuccessDate: this.workflowDetails?.lastSuccessDate || null,
            workflowPermissions: [],
            workflowConditions: [],
            accountChannelId: accountChannelId || null,
            accountChannelName: accountChannelName || null
        }

        this.workflowDetailsForm.getRawValue().selectedUsers?.map(userDetails=>{
            let id = 0;

            if(this.workflowDetails && !this.workflowCopy){
                const addedUser = this.workflowDetails.workflowPermissions.find(user=>user.userId==userDetails.id);
                id = addedUser ? addedUser.id : 0;
            }

            workflowData.workflowPermissions.push({
                id: id,
                workflowId: this.workflowDetailsForm.getRawValue().id,
                userId: userDetails.id,
                userName: userDetails.name,
                statusId: 1
            })
        });

        //Set removed
        if(this.workflowDetails && !this.workflowCopy){
            this.workflowDetails.workflowPermissions.map(userDetails=>{
                const addedUser = workflowData.workflowPermissions.find(user=>user.userId==userDetails.userId);
                if(!addedUser){
                    workflowData.workflowPermissions.push({
                        ...userDetails,
                        statusId: 3
                    })
                }
            })
        }

        const addedCondtions: WorkflowModelsNS.WorkflowAddEditCondtions[] = this.prepareWorkflowConditions(this.conditionGroup);
        workflowData.workflowConditions = addedCondtions;

        if(workflowData.id>0){
            this.appMainService.isShowSpinner('SaveNewWorkflow');
            this.workflowService.updateWorkflow(workflowData).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response)=>{
                    this.appMainService.isHideSpinner('SaveNewWorkflow');
                    this.loadingWorkflowSave = false;
                    this.messageService.add({ severity: WorkflowMessages.success.toLowerCase(), summary: WorkflowMessages.success, detail: WorkflowMessages.updateSuccessMsg });
                    this.loadNewList.emit(true);
                    this.closeDialog();
                },
                error: (error)=>{
                    this.appMainService.isHideSpinner('SaveNewWorkflow');
                    this.loadingWorkflowSave = false;
                    this.messageService.add({ severity: WorkflowMessages.error.toLowerCase(), summary: WorkflowMessages.error, detail: WorkflowMessages.updateErrorMsg });
                }
            })
        }else{
            this.appMainService.isShowSpinner('SaveNewWorkflow');
            this.workflowService.addNewWorkflow(workflowData).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response)=>{
                    this.appMainService.isHideSpinner('SaveNewWorkflow');
                    this.loadingWorkflowSave = false;
                    this.messageService.add({ severity: WorkflowMessages.success.toLowerCase(), summary: WorkflowMessages.success, detail: WorkflowMessages.saveSuccessMsg });
                    this.loadNewList.emit(true);
                    this.closeDialog();
                },
                error: (error)=>{
                    this.appMainService.isHideSpinner('SaveNewWorkflow');
                    this.loadingWorkflowSave = false;
                    this.messageService.add({ severity: WorkflowMessages.error.toLowerCase(), summary: WorkflowMessages.error, detail: WorkflowMessages.saveErrorMsg });
                }
            })
        }



    }

    prepareWorkflowConditions(conditionGroup: WorkflowModelsNS.WorkflowAddedEditConditionGroup[]): WorkflowModelsNS.WorkflowAddEditCondtions[] {
        const allCondtions: WorkflowModelsNS.WorkflowAddEditCondtions[] = [];

        conditionGroup?.map((addedCondition, conditionIndex)=>{

            let existedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup = null;
            let prevousRawCondition: WorkflowModelsNS.WorkflowDetailsConditions = null;

            if(addedCondition?.conditionId>0 && this.workflowDetails && this.tempConditionGroup){
                existedCondition = this.tempConditionGroup.find(condition=> condition.conditionId===addedCondition.conditionId)||null;
                prevousRawCondition = this.workflowDetails.workflowConditions.find(condition=> condition.id===addedCondition.conditionId)||null;
            }

            const conditionData: WorkflowModelsNS.WorkflowAddEditCondtions = {
                id: addedCondition?.conditionId,
                workflowId: this.workflowDetailsForm.getRawValue().id,
                isMannualCondition: addedCondition.type==='manual' ? true : false,
                saveSearchId: addedCondition.savedSearchId||0,
                order: conditionIndex,
                description: "",
                statusId: addedCondition.statusId,
                savedSearch: null,
                savedSearchUpdate: null,
                workflowActions: []
            }

            if(conditionData.saveSearchId==0 && conditionData.isMannualCondition && addedCondition.ruleData){
                conditionData.savedSearch = this.prepareNewSaveSearch('Save', addedCondition.ruleData, addedCondition);
            }else if(this.workflowDetails && addedCondition.ruleData && conditionData.isMannualCondition){
                conditionData.savedSearchUpdate = this.prepareUpdateSaveSearch('Save', addedCondition.ruleData, prevousRawCondition, addedCondition);
            }


            if(addedCondition.instantActions.id>0 || addedCondition.instantActions?.workflowActionTasks?.length>0 || addedCondition.instantActions?.workflowActionEmails?.length || addedCondition.instantActions?.workflowActionUpdateFields?.length>0 || addedCondition.instantActions?.workflowActionCreateRecords?.length>0 || addedCondition.instantActions?.workflowActionApprovals?.length>0 || addedCondition.instantActions?.workflowActionUpdateRecords?.length>0 || addedCondition.instantActions?.workflowActionConvertToInvoices?.length>0 || addedCondition.instantActions?.workflowActionDeleteRecords?.length>0){
                const workflowInstantActionDetails: WorkflowModelsNS.WorkflowAddEditActions = {
                    id: addedCondition.instantActions?.id||0,
                    workflowConditionId: addedCondition?.conditionId||0,
                    workflowActionType: WorkflowModelsNS.OccurrenceTypeEnum.INSTANT,
                    order: 1,
                    statusId: addedCondition.instantActions?.statusId||1,
                    occurrenceType: WorkflowModelsNS.OccurrenceTypeEnum.INSTANT,
                    occurrenceBase: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Days,
                    dateTimeFieldName: 'ExecutionDateTime',
                    workflowActionTasks: ParseHelper.DeepCopy(addedCondition.instantActions?.workflowActionTasks||[]),
                    workflowActionEmails: ParseHelper.DeepCopy(addedCondition.instantActions?.workflowActionEmails||[]),
                    workflowActionUpdateFields: ParseHelper.DeepCopy(addedCondition.instantActions?.workflowActionUpdateFields||[]),
                    workflowActionCreateRecords: ParseHelper.DeepCopy(addedCondition.instantActions?.workflowActionCreateRecords||[]),
                    workflowActionUpdateRecords: ParseHelper.DeepCopy(addedCondition.instantActions?.workflowActionUpdateRecords||[]),
                    workflowActionConvertToInvoices: ParseHelper.DeepCopy(addedCondition.instantActions?.workflowActionConvertToInvoices||[]),
                    workflowActionDeleteRecords: ParseHelper.DeepCopy(addedCondition.instantActions?.workflowActionDeleteRecords||[]),
                    workflowActionApprovals: ParseHelper.DeepCopy(addedCondition.instantActions?.workflowActionApprovals||[]),
                }

                //Set removed actions
                if(existedCondition){
                    existedCondition?.instantActions?.workflowActionTasks?.map(addedTask=>{
                        const exist = workflowInstantActionDetails.workflowActionTasks.find(task=>task.id==addedTask.id);
                        if(!exist){
                            workflowInstantActionDetails.workflowActionTasks.push({
                                ...addedTask,
                                statusId: 3
                            })
                        }
                    })

                    existedCondition?.instantActions?.workflowActionEmails?.map(addedEmail=>{
                        const exist = workflowInstantActionDetails.workflowActionEmails.find(task=>task.id==addedEmail.id);
                        if(!exist){
                            workflowInstantActionDetails.workflowActionEmails.push({
                                ...addedEmail,
                                statusId: 3
                            })
                        }
                    })

                    existedCondition?.instantActions?.workflowActionUpdateFields?.map(addedField=>{
                        const exist = workflowInstantActionDetails.workflowActionUpdateFields.find(task=>task.id==addedField.id);
                        if(!exist){
                            workflowInstantActionDetails.workflowActionUpdateFields.push({
                                ...addedField,
                                statusId: 3
                            })
                        }
                    })

                    existedCondition?.instantActions?.workflowActionCreateRecords?.map(addedRecord=>{
                        const exist = workflowInstantActionDetails.workflowActionCreateRecords.find(record=>record.id==addedRecord.id);
                        if(!exist){
                            workflowInstantActionDetails.workflowActionCreateRecords.push({
                                ...addedRecord,
                                statusId: 3
                            })
                        }
                    })

                    existedCondition?.instantActions?.workflowActionApprovals?.map(addedApprovals=>{
                        const exist = workflowInstantActionDetails.workflowActionApprovals.find(record=>record.id==addedApprovals.id);
                        if(!exist){
                            workflowInstantActionDetails.workflowActionApprovals.push({
                                ...addedApprovals,
                                statusId: 3
                            })
                        }
                    })

                    existedCondition?.instantActions?.workflowActionUpdateRecords?.map(addedRecord=>{
                        const exist = workflowInstantActionDetails.workflowActionUpdateRecords.find(record=>record.id==addedRecord.id);
                        if(!exist){
                            workflowInstantActionDetails.workflowActionUpdateRecords.push({
                                ...addedRecord,
                                statusId: 3
                            })
                        }
                    })

                    existedCondition?.instantActions?.workflowActionConvertToInvoices?.map(addedRecord=>{
                        const exist = workflowInstantActionDetails.workflowActionConvertToInvoices.find(record=>record.id==addedRecord.id);
                        if(!exist){
                            workflowInstantActionDetails.workflowActionConvertToInvoices.push({
                                ...addedRecord,
                                statusId: 3
                            })
                        }
                    })

                    existedCondition?.instantActions?.workflowActionDeleteRecords?.map(addedRecord=>{
                        const exist = workflowInstantActionDetails.workflowActionDeleteRecords.find(record=>record.id==addedRecord.id);
                        if(!exist){
                            workflowInstantActionDetails.workflowActionDeleteRecords.push({
                                ...addedRecord,
                                statusId: 3
                            })
                        }
                    })


                }

                conditionData.workflowActions.push(workflowInstantActionDetails)
            }

            if(this.workflowDetailsForm.value?.selectedTriggerType?.allowTimeDependent){
                addedCondition.timeDependentActions.map((timeDependentAction, index)=>{
                    const workflowActionDetails: WorkflowModelsNS.WorkflowAddEditActions = {
                        id: timeDependentAction?.id||0,
                        workflowConditionId: addedCondition?.conditionId||0,
                        workflowActionType: WorkflowModelsNS.OccurrenceTypeEnum.TIME_DEPENDENT,
                        order: (index+2),
                        statusId: timeDependentAction.statusId||1,
                        dateTimeFieldName: 'ExecutionDateTime',
                        occurrenceBase: timeDependentAction.occurrenceBase,
                        occurrenceValue: timeDependentAction.addOrSubstractBase==this.addOrSubstractBases[0].id ? timeDependentAction.occurrenceValue : -Math.abs(timeDependentAction.occurrenceValue),
                        occurrenceType: WorkflowModelsNS.OccurrenceTypeEnum.TIME_DEPENDENT,
                        workflowActionTasks: ParseHelper.DeepCopy(timeDependentAction?.workflowActionTasks||[]),
                        workflowActionEmails: ParseHelper.DeepCopy(timeDependentAction?.workflowActionEmails||[]),
                        workflowActionUpdateFields: ParseHelper.DeepCopy(timeDependentAction?.workflowActionUpdateFields||[]),
                        workflowActionCreateRecords: ParseHelper.DeepCopy(timeDependentAction?.workflowActionCreateRecords||[]),
                        workflowActionUpdateRecords: ParseHelper.DeepCopy(timeDependentAction?.workflowActionUpdateRecords||[]),
                        workflowActionConvertToInvoices: ParseHelper.DeepCopy(timeDependentAction?.workflowActionConvertToInvoices||[]),
                        workflowActionDeleteRecords: ParseHelper.DeepCopy(timeDependentAction?.workflowActionDeleteRecords||[]),
                        workflowActionApprovals: ParseHelper.DeepCopy(timeDependentAction?.workflowActionApprovals||[]),
                    }

                    //Set Removed actions
                    if(existedCondition){
                        const previousTimeDependentAction = existedCondition.timeDependentActions.find(action=>action.id===timeDependentAction?.id);
                        if(previousTimeDependentAction){
                            previousTimeDependentAction?.workflowActionTasks?.map(addedTask=>{
                                const exist = workflowActionDetails.workflowActionTasks.find(task=>task.id==addedTask.id);
                                if(!exist){
                                    workflowActionDetails.workflowActionTasks.push({
                                        ...addedTask,
                                        statusId: 3
                                    })
                                }
                            })

                            previousTimeDependentAction?.workflowActionEmails?.map(addedEmail=>{
                                const exist = workflowActionDetails.workflowActionEmails.find(task=>task.id==addedEmail.id);
                                if(!exist){
                                    workflowActionDetails.workflowActionEmails.push({
                                        ...addedEmail,
                                        statusId: 3
                                    })
                                }
                            })

                            previousTimeDependentAction?.workflowActionUpdateFields?.map(addedField=>{
                                const exist = workflowActionDetails.workflowActionUpdateFields.find(task=>task.id==addedField.id);
                                if(!exist){
                                    workflowActionDetails.workflowActionUpdateFields.push({
                                        ...addedField,
                                        statusId: 3
                                    })
                                }
                            })

                            previousTimeDependentAction?.workflowActionCreateRecords?.map(addedRecord=>{
                                const exist = workflowActionDetails.workflowActionCreateRecords.find(record=>record.id==addedRecord.id);
                                if(!exist){
                                    workflowActionDetails.workflowActionCreateRecords.push({
                                        ...addedRecord,
                                        statusId: 3
                                    })
                                }
                            })

                            previousTimeDependentAction?.workflowActionApprovals?.map(addedApproval=>{
                                const exist = workflowActionDetails.workflowActionApprovals.find(record=>record.id==addedApproval.id);
                                if(!exist){
                                    workflowActionDetails.workflowActionApprovals.push({
                                        ...addedApproval,
                                        statusId: 3
                                    })
                                }
                            })

                            previousTimeDependentAction?.workflowActionUpdateRecords?.map(addedRecord=>{
                                const exist = workflowActionDetails.workflowActionUpdateRecords.find(record=>record.id==addedRecord.id);
                                if(!exist){
                                    workflowActionDetails.workflowActionUpdateRecords.push({
                                        ...addedRecord,
                                        statusId: 3
                                    })
                                }
                            })

                            previousTimeDependentAction?.workflowActionConvertToInvoices?.map(addedRecord=>{
                                const exist = workflowActionDetails.workflowActionConvertToInvoices.find(record=>record.id==addedRecord.id);
                                if(!exist){
                                    workflowActionDetails.workflowActionConvertToInvoices.push({
                                        ...addedRecord,
                                        statusId: 3
                                    })
                                }
                            })

                            previousTimeDependentAction?.workflowActionDeleteRecords?.map(addedRecord=>{
                                const exist = workflowActionDetails.workflowActionDeleteRecords.find(record=>record.id==addedRecord.id);
                                if(!exist){
                                    workflowActionDetails.workflowActionDeleteRecords.push({
                                        ...addedRecord,
                                        statusId: 3
                                    })
                                }
                            })


                        }
                    }

                    conditionData.workflowActions.push(workflowActionDetails);
                })
            }

            //Set removed actions type
            if(prevousRawCondition){
                prevousRawCondition.workflowActions.map(actionDetails=>{
                    const actionExist = conditionData.workflowActions.find(action=>action.id===actionDetails?.id);

                    if(!actionExist){
                        const workflowActionDetails = {
                            ...actionDetails,
                            statusId: 3
                        }
                        conditionData.workflowActions.push(workflowActionDetails);
                    }
                })
            }


            allCondtions.push(conditionData)
        })

        return allCondtions;
    }


    //Saved-Searche Preview
    previewSavedSearch(type: 'Save' | 'Preview', ruleData: SavedSearchNS.IRuleList[], addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup): void {
        //Prepare saved-search object
        const newSavedSearches = this.prepareNewSaveSearch(type, ruleData, addedCondition);
        const mainRuleExist = newSavedSearches?.savedSearchRuleRequest?.find(x => x.isMainModule == true);
        // console.log(newSavedSearches);
        // return
        if (mainRuleExist) {
            this.appMainService.isShowSpinner('SaveNewSavedSearch');
            this.savedSearchesService.addSavedSearch(newSavedSearches).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
                this.appMainService.isHideSpinner('SaveNewSavedSearch');
                if (type == 'Preview') {
                    this.preparePreviewDataList(res);
                }
            },
            error => {
                this.appMainService.isHideSpinner('SaveNewSavedSearch');
                if (type != 'Preview') {
                    this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: SavedSearchMessage.saveSearchaveErrorMsg });
                }
            });
        }
        else {
            this.messageService.add({ severity: SavedSearchMessage.warning.toLowerCase(), summary: SavedSearchMessage.warning, detail: 'At least 1 parent rule must be added.' });
        }
    }

    //Prepare Preview Data List
    preparePreviewDataList(res: any) {
        this.displaySSPreviewDataList = true;
        // let previewColumnList: SavedSearchNS.ISavedSearchPreviceColumnModel[] = [];
        if (res?.Result) {
            this.ssPreviewDataList = res?.Result;
            this.ssPreviewColumnList = getSavedSearchTableColumns(res?.savedSearchColumnSetting ?? []) ?? [];
        }
    }

    prepareNewSaveSearch(type: 'Save' | 'Preview', ruleData: SavedSearchNS.IRuleList[], addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup): SavedSearchNS.NewSavedSearches {

        const uniqueName = Guid.create();

        let newSavedSearches: SavedSearchNS.NewSavedSearches = {
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            name: uniqueName.toString(),
            description: this.workflowDetailsForm.getRawValue().description,
            moduleId: this.workflowDetailsForm.getRawValue().selectedModule?.objectId,
            channelId: this.workflowDetailsForm.getRawValue().selectedChannel?.channelId,
            accountChannelId: this.workflowDetailsForm.getRawValue().selectedAccountChannel?.id||null,
            isCombinational: addedCondition?.isCombinational||false,
            ruleCombination: addedCondition?.ruleCombination||"",
            statusId: this.workflowDetailsForm.getRawValue().isActive == true ? 1 : 2,
            isPreview: type == 'Preview' ? true : false,
            previewId: 0,
            savedSearchRuleRequest: [],
            savedSearchUserPermissionRequest: [],
        };

        let savedSearchRule: SavedSearchNS.SavedSearchRuleRequest[] = [];
        let sequenceOrder = 0;
        ruleData.forEach(rule => {
            sequenceOrder += 1;
            const { values, valueRefId } = getSavedSearchRuleValues(rule);
            let objectId: number = rule?.module ? (rule.module.objectId ? rule.module.objectId : this.parentModulesCopy?.find(x => x.id == rule.module.id)?.objectId) : rule?.objectId;
            savedSearchRule.push(
                {
                    id: 0,
                    ruleNo: rule?.ruleNo,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    // createdBy: number;
                    // updatedBy: number;
                    // createdDate: string;
                    // updatedDate: string;
                    savedSearchId: 0,
                    objectId: objectId,
                    objectName: rule?.module?.name||rule?.objectName,
                    isMainModule: rule.isMainModule,
                    // criteria: rule.filter.field,
                    criteria: rule.filter.custom ? rule.filter.name : rule.filter.field.charAt(0).toUpperCase() + rule.filter.field.slice(1),//UpperCase First Later
                    equation: rule.operator.name,
                    values: values,
                    valueRefId: valueRefId,
                    operator: rule.choice?.name,
                    isCustom: rule.filter.custom,
                    dataType: rule.filter.fieldDataType,
                    statusId: 1,
                    // status?: null,
                    // isValid: ,
                    sequenceOrder: sequenceOrder,
                    templateId: rule.template.id,
                    templateName: rule.template.templateName,
                    // validFromDate: string;
                    // validToDate: string;
                    // savedSearchRuleDetails: SavedSearchRuleDetail[];
                    labelName: null,
                    parentLabelName: null,
                    compareWithField: rule?.compareWithField||false,
                    comparisonCriteria: rule?.comparisonCriteria||null,
                    comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                    comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                    isCustomComparisonCriteria: rule?.isCustomComparisonCriteria||false,
                    comparisonCriteriaObject: rule?.comparisonCriteriaObject||null,
                    customAttributeObjectId: rule?.customAttributeObjectId||null,
                    comparisonCustomAttributeObjectId: rule?.comparisonCustomAttributeObjectId||null,
                    // accountChannelId: null,
                    accountChannelId: this.workflowDetailsForm.getRawValue().selectedModule?.name == 'Estimate' || this.workflowDetailsForm.getRawValue().selectedModule?.name == 'Invoice' || this.workflowDetailsForm.getRawValue().selectedModule?.name == 'Opportunity' || this.workflowDetailsForm.getRawValue().selectedModule?.name == 'SalesOrder' || this.workflowDetailsForm.getRawValue().selectedModule?.name == 'PurchaseOrder' ? this.workflowDetailsForm.getRawValue().selectedAccountChannel?.id :
                    this.workflowDetailsForm.getRawValue().selectedModule?.name == 'Product' ? (this.workflowDetailsForm.getRawValue().selectedChannel?.channelId) : null,
                }
            );
            // }
        });
        newSavedSearches.savedSearchRuleRequest = savedSearchRule;

        //UserPermission
        let savedSearchUserPermission: SavedSearchNS.SavedSearchUserPermissionRequest[] = [];
        this.workflowDetailsForm.getRawValue().selectedUsers?.forEach(user => {
            savedSearchUserPermission.push({ id: 0, savedSearchId: 0, userId: user.id, userName: user.name, statusId: 1 });
        });
        newSavedSearches.savedSearchUserPermissionRequest = savedSearchUserPermission;
        return newSavedSearches;
    }

    prepareUpdateSaveSearch(type: 'Save' | 'Preview', ruleData: SavedSearchNS.IRuleList[],
        prevousRawCondition: WorkflowModelsNS.WorkflowDetailsConditions,
        addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup): any {

        const uniqueName = Guid.create();

        let updateSavedSearches: SavedSearchNS.UpdateSavedSearches = {
            id: prevousRawCondition?.saveSearchId||0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            name: uniqueName.toString(),
            description: this.workflowDetailsForm.getRawValue().description,
            moduleId: this.workflowDetailsForm.getRawValue().selectedModule?.objectId,
            channelId: this.workflowDetailsForm.getRawValue().selectedChannel?.channelId,
            accountChannelId: this.workflowDetailsForm.getRawValue().selectedAccountChannel?.id||null,
            isCombinational: addedCondition?.isCombinational||false,
            ruleCombination: addedCondition?.ruleCombination||"",
            statusId: this.workflowDetailsForm.getRawValue().isActive == true ? 1 : 2,
            createdBy: this.app.userId ?? 0,
            createdDate: new Date().toISOString(),
            savedSearchRuleUpdateRequest: [],
            savedSearchUserPermissionUpdateRequest: [],
        };

        let savedSearchRule: SavedSearchNS.SavedSearchRuleUpdateRequest[] = [];
        let sequenceOrder = 0;
        ruleData.forEach(rule => {
            sequenceOrder += 1;
            const { values, valueRefId } = getSavedSearchRuleValues(rule);
            savedSearchRule.push(
                {
                    id: rule.id ?? 0,
                    ruleNo: rule?.ruleNo,
                    updatedSource: this.app.userIP,
                    // createdBy: number;
                    // updatedBy: number;
                    // createdDate: string;
                    // updatedDate: string;
                    // savedSearchId: this.savedSearchesId,
                    objectId: rule.module?.objectId ?? rule.objectId,
                    objectName: rule.module?.name ?? rule.objectName,
                    isMainModule: rule.isMainModule,
                    // criteria: rule.filter.field,
                    criteria: rule.filter.custom ? rule.filter.name : rule.filter.field.charAt(0).toUpperCase() + rule.filter.field.slice(1),//UpperCase First Later
                    equation: rule.operator.name,
                    values: values,
                    valueRefId: valueRefId,
                    operator: rule.choice?.name,
                    isCustom: rule.filter.custom,
                    dataType: rule.filter.fieldDataType,
                    statusId: 1,
                    // status?: null,
                    // isValid: ,
                    sequenceOrder: sequenceOrder,
                    templateId: rule.template.id,
                    templateName: rule.template.templateName,
                    // validFromDate: string;
                    // validToDate: string;
                    // savedSearchRuleDetails: SavedSearchRuleDetail[];
                    // labelName: null,
                    createdBy: this.app.userId,
                    createdDate: new Date().toISOString(),
                    accountChannelId: rule.accountChannel?.id ?? null,
                    compareWithField: rule?.compareWithField||false,
                    comparisonCriteria: rule?.comparisonCriteria||null,
                    comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                    comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                    isCustomComparisonCriteria: rule?.isCustomComparisonCriteria||false,
                    comparisonCriteriaObject: rule?.comparisonCriteriaObject||null,
                    customAttributeObjectId: rule?.customAttributeObjectId||null,
                    comparisonCustomAttributeObjectId: rule?.comparisonCustomAttributeObjectId||null
                }
            );
        });
        updateSavedSearches.savedSearchRuleUpdateRequest = savedSearchRule;

        //UserPermissino
        let savedSearchUserPermission: SavedSearchNS.SavedSearchUserPermissionUpdateRequest[] = [];
        this.workflowDetailsForm.getRawValue().selectedUsers?.forEach(user => {
            const userPermission = prevousRawCondition?.savedSearchInfo?.savedSearchUserPermission?.find(x => x.userId == user.id);
            savedSearchUserPermission.push({ id: userPermission?.id ?? 0, userId: user.id, userName: user.name, statusId: 1, createdBy: this.app.userId ?? 0, createdDate: new Date().toISOString(), updatedSource: this.app.userIP });
        });
        updateSavedSearches.savedSearchUserPermissionUpdateRequest = savedSearchUserPermission;
        return updateSavedSearches;
    }

    //#endregion

    //Dropdown Event Methods

    onChangeParentModule(){
        if(this.conditionGroup.length>0){
            this.confirmationService.confirm({
                message: WorkflowMessages.clearRulesMessage,
                header: WorkflowMessages.rulesClearConfirmation,
                icon: 'pi pi-info-circle',
                accept: () => {
                    this.clearConditions();
                    this.selectParentModule();
                    this.checkModuleAndSetFieldValidation();
                },
                reject: () => {
                    this.workflowDetailsForm.patchValue({
                        selectedModule: this.selectedModule
                    },{onlySelf: true});
                }
            });
        }else{
            this.selectParentModule();
            this.checkModuleAndSetFieldValidation();
        }
    }

    selectParentModule(){
        this.selectedModule = this.workflowDetailsForm.getRawValue().selectedModule;
        this.selectedActionModule = this.actionModules.find(m=> m.objectId==this.selectedModule?.objectId)||null;
        this.workflowDetailsForm.patchValue({
            selectedChannel: null,
            // selectedAccountChannel: null
        },{onlySelf: true});
        this.selectedAssoModule = null;
        this.selectedAssoTemplate = null;
        this.activeActionsDD = this.actionsDD.filter(list=> list.activeModules.includes(this.selectedModule?.objectId));
        this.getTemplateList(true, this.selectedModule, null);
        this.getChildModuleDetails();
    }

    selectActionModule(){
        if(this.selectedActionModule?.objectId)
            this.activeActionsDD = this.actionsDD.filter(list=> list.activeModules.includes(this.selectedActionModule?.objectId));
        else
            this.activeActionsDD = this.actionsDD.filter(list=> list.activeModules.includes(this.selectedModule?.objectId));
    }

    /**
     * Account channel dropdown should be visible for
     * Inventory Module
     */
    checkModuleAndSetFieldValidation(){
        if(this.accountChannelsFor.includes(this.workflowDetailsForm.getRawValue().selectedModule?.name)){
            this.setAccountChannelFieldValueAndValidation();
        } else {
            this.clearAccountChannelFieldValueAndValidation();
        }

        // if(this.workflowDetailsForm.getRawValue().selectedModule?.name=='Product'){
        //     this.setProductFieldValueAndValidation();
        // } else {
        //     this.clearProductFieldValueAndValidation();
        // }
    }

    setAccountChannelFieldValueAndValidation(){
        const accChannelControl = this.workflowDetailsForm.get('selectedAccountChannel');
        accChannelControl.setValue(null);
        accChannelControl.setValidators([Validators.required]);
        accChannelControl.updateValueAndValidity();
    }

    clearAccountChannelFieldValueAndValidation(){
        const accChannelControl = this.workflowDetailsForm.get('selectedAccountChannel');
        accChannelControl.setValue(null);
        accChannelControl.clearValidators();
        accChannelControl.updateValueAndValidity();
    }

    setProductFieldValueAndValidation(){
        const warehouseControl = this.workflowDetailsForm.get('wareHouseLocationId');
        const defaultWareHouseId = this.wareHouseLocationList.find(x=> x?.isDefault)?.id||null;
        warehouseControl.setValue(defaultWareHouseId);
        warehouseControl.setValidators([Validators.required]);
        warehouseControl.updateValueAndValidity();
    }

    clearProductFieldValueAndValidation(){
        const warehouseControl = this.workflowDetailsForm.get('wareHouseLocationId');
        warehouseControl.setValue(null);
        warehouseControl.clearValidators();
        warehouseControl.updateValueAndValidity();
    }

    onChangeParentChannel(){
        if(this.conditionGroup.length>0){
            this.confirmationService.confirm({
                message: WorkflowMessages.clearRulesMessage,
                header: WorkflowMessages.rulesClearConfirmation,
                icon: 'pi pi-info-circle',
                accept: () => {
                    this.clearConditions();
                    this.selectParentChannel();
                },
                reject: () => {
                    this.workflowDetailsForm.patchValue({
                        selectedChannel: this.selectedTemplate
                    },{onlySelf: true, emitEvent: false});
                }
            });
        }else{
            this.selectParentChannel();
        }
    }

    selectParentChannel(){
        this.selectedTemplate = this.workflowDetailsForm.getRawValue().selectedChannel;
        this.selectedAssoTemplate = this.workflowDetailsForm.getRawValue().selectedChannel;
    }

    selectAssociateModule(){
        // this.getTemplateList(false, this.selectedAssoModule, null);
    }

    selectAssociateChannel(){
        // this.getFieldListByTemplate(false, selectedAssoTemplate, null)
    }

    selectOccurenceBase(updateValue: boolean = false){
        const selectedBase = this.workflowDetailsForm.getRawValue().occurrenceBase;
        this.occurrenceValues = [];


        switch (selectedBase.id) {
            case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Years:
                this.occurrenceValues = [1];
                break;
            case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Months:
                for(let i=1; i<=11; i++){this.occurrenceValues.push(i)}
                break;
            case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Days:
                for(let i=1; i<=28; i++){this.occurrenceValues.push(i)}
                break;
            case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Hours:

                for(let i=1; i<=23; i++){this.occurrenceValues.push(i)}
                break;
            case WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Minutes:
                this.occurrenceValues = [5,10,15,30];
                break;
            default:
                break;
        }

        if(updateValue){ this.workflowDetailsForm.patchValue({occurrenceValue: this.occurrenceValues[0]}) }

    }


    //#region ***Dropdown List Loading***
    //For permission
    getUsers() {
        this.userService.getUsers(this.app.companyId).then((users: SavedSearchNS.IUser[]) => {
            if (users && users.length) {
                this.users = users?.sort((a, b) => a.name.localeCompare(b.name)).filter(user => user.statusId == 1)
                    .map(x => { return { name: x.name, id: x.id, inactive: x.id == this.app.userId ? true : false }; })

                // const selectedUsers = this.users.filter(user=> user.id===this.app.userId)||[];
                // this.workflowDetailsForm.patchValue({
                //     selectedUsers: selectedUsers
                // })
            }
        });
    }

    getUserTree(){
        this.configService.getAllUserOrgChartData(this.app.userId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                if(response){
                    this.activeUserTree = this.copyUserTree(response);
                    this.setSelectedUsers();
                }
            },
            error: (error)=>{

            }
        })
    }

    setSelectedUsers(){
        const userList = this.getFlatArrayFormChilren(this.activeUserTree)||[];
        let selectedUsr = userList.find(user => user.id == this.app.user.userId);
        if(this.workflowDetails){
            const selectedUsers: any[] = [];
            this.workflowDetails.workflowPermissions.map(userDetails=>{
                const selectedUser = userList.find(user=> user.id===userDetails.userId);

                if(selectedUser){
                    selectedUsers.push(selectedUser)
                }
            })

            if(selectedUsers.length==0){
                selectedUsers.push(selectedUsr);
            }
            this.workflowDetailsForm.patchValue({
                selectedUsers: selectedUsers||null
            })
        }else{
            const selectedUsers = [selectedUsr];
            this.workflowDetailsForm.patchValue({
                selectedUsers: selectedUsers||null
            })
        }
    }

    onUserSelect($event: any){
        const selectedUsers = this.workflowDetailsForm.getRawValue().selectedUsers;
        const exist = selectedUsers.find(x=> x.id==$event?.node?.id);

        if(exist || !$event?.node?.id){
            setTimeout(()=>{
                this.workflowDetailsForm.patchValue({
                    selectedUsers: selectedUsers
                },{onlySelf: true, emitEvent: false})
            })
        }

    }

    copyUserTree(originalTree: Array<object>): Array<object> {
        return originalTree.map(({ childUsers, ...data }: any) => ({
            id: data.id,
            label: `${data.name}${data?.role ? (data.name ? ' - ' : '') + data?.role : ''}`,
            name: data.name,
            selectable : data.id == this.app.userId ? false : true,
            children: this.copyUserTree(childUsers)
        }));
    }

    getFlatArrayFormChilren(members: any[]){
        let children = [];
        return members.map(m => {
          if (m.children && m.children.length) {
            children = [...children, ...m.children];
          }
          return m;
        }).concat(children.length ? this.getFlatArrayFormChilren(children) : children);
    }

    getModuleDetails() {
        this.appMainService.isShowSpinner("loadModules");
        this.savedSearchesService.getAllModules('SavedSearchModule')
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner("loadModules");
                    let resValue = [];
                    if (response) {
                        resValue = response?.map(x => ({ ...x, isMainModule: true }));
                    }
                    // InvoiceOrderModuleId,SOModuleId,EstimateOrderModuleId modules hidden
                    this.parentModules = resValue.filter(moduleDetails=> [LeadModuleId,AccountModuleId,OpportunityModuleId,ProductModuleId,VendorModuleId,TaskModuleId,LocationModuleId].includes(moduleDetails.objectId)); //For Now Workflow Implemented for Only Lead, Account and Product
                    this.parentModulesCopy = JSON.parse(JSON.stringify(resValue));

                    if(this.workflowEditId>0 && this.workflowDetails){
                        const selectedModule = this.parentModules.find(moduleDetails=> moduleDetails.objectId===this.workflowDetails.objectId);

                        if(selectedModule){
                            this.workflowDetailsForm.patchValue({
                                selectedModule: selectedModule
                            },{onlySelf: true, emitEvent: false});

                            this.selectParentModule();
                        }
                    }
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadModules");
                    this.messageService.add({
                        severity: 'error',
                        summary: 'error',
                        detail: "Error occurred...",
                    });
                }
            });
        // this.parentModules = ParentModules;
    }

    getChildModuleDetails() {
        if (this.workflowDetailsForm.getRawValue().selectedModule?.name) {
            this.savedSearchesService.getSaveSearchObject('SavedSearchModule', this.workflowDetailsForm.getRawValue().selectedModule.name).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res: SavedSearchNS.IObjectType) => {
                this.assoModules = res.childobject;
                if (res.objectId === VendorModuleId && Array.isArray(this.assoModules)) {
                    const purchase = this.assoModules.find(child => child.objectId === PurchaseOrderModuleId);
                    if (purchase) {
                        purchase.name = 'Purchases';
                    }
                  }
                this.workflowDetailsForm.getRawValue().selectedModule['objectId'] = res?.objectId ?? this.workflowDetailsForm.getRawValue().selectedModule['objectId'];
            });
        }
    }

    //get template list by module
    getTemplateList(isMainModuleModule: boolean, data: SavedSearchNS.IObjectType, mainModule: SavedSearchNS.SavedSearchRuleRequest) {

        if (data !== null) {
            this.appMainService.isShowSpinner('getTemplateList');

            if ([AccountModuleId,LeadModuleId,OpportunityModuleId,VendorModuleId,TaskModuleId,LocationModuleId].includes(data?.objectId)){
                const allList = [OpportunityModuleId,VendorModuleId,TaskModuleId,LocationModuleId].includes(data?.objectId);
                this.sharedChannelService.getChannels(data?.objectId,allList).subscribe({
                    next: (response) => {
                        this.appMainService.isHideSpinner('getTemplateList');
                        let channels = response || [];

                        switch (data?.objectId) {
                            case AccountModuleId:
                                channels = this.permissionService.filterChannelsByPermissions(channels,ObjectNames.ACCOUNT);
                                break;
                            case LeadModuleId:
                                channels = this.permissionService.filterChannelsByPermissions(channels,ObjectNames.LEAD);
                                break;
                            case OpportunityModuleId:
                                channels = this.permissionService.filterChannelsByPermissions(channels,ObjectNames.OPPORTUNITY);
                                break;
                            default:
                                break;
                        }

                        const processedData = channels.map((obj) => {
                            return {
                                id: obj?.id,
                                templateName: obj?.name,
                                channelName: obj?.name,
                                channelId: obj?.id,
                                objectId: data?.objectId
                            }
                        });

                        this.assoTemplates = processedData;

                        if (isMainModuleModule){
                            this.parentTemplates = processedData;

                            if(this.workflowEditId>0 && this.workflowDetails){
                                const selectedChannel = this.parentTemplates.find(templateDetails=> templateDetails.channelId===this.workflowDetails.channelId);

                                if(selectedChannel){
                                    this.workflowDetailsForm.patchValue({
                                        selectedChannel: selectedChannel
                                    },{onlySelf: true});
                                    this.selectedAssoTemplate = selectedChannel;
                                    this.selectParentChannel();
                                }
                            }else if([VendorModuleId,TaskModuleId,LocationModuleId].includes(data?.objectId) && this.parentTemplates?.length>0){
                                this.workflowDetailsForm.patchValue({
                                    selectedChannel: this.parentTemplates[0]
                                },{onlySelf: true});
                                this.selectedAssoTemplate = this.parentTemplates[0];
                                this.selectParentChannel();
                            }
                        }else{
                            this.selectedAssoTemplate = this.assoTemplates.find(x => x.id == mainModule.templateId);
                        }



                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getTemplateList');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.message : 'Templates are not loaded, please try again...'
                        });

                    }
                  });
            }else{
                this.configService.getConfigurationsByTemplateName(`${data.name} Template`).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
                    this.appMainService.isHideSpinner('getTemplateList');
                    if (isMainModuleModule) {
                        if (mainModule?.templateId > 0) {
                            this.parentTemplates = resp.templates?.filter(x => x.isActive == true || x.id == mainModule?.templateId) ?? [];
                        }
                        else {
                            this.parentTemplates = resp.templates?.filter(x => x.isActive == true);
                        }
                        this.parentTemplates = this.parentTemplates.map(x => { x.objectId = resp.configuration?.objectId; return x; });

                        if(this.workflowEditId>0 && this.workflowDetails){
                            const selectedChannel = this.parentTemplates.find(templateDetails=> templateDetails.channelId===this.workflowDetails.channelId);

                            if(selectedChannel){
                                this.workflowDetailsForm.patchValue({
                                    selectedChannel: selectedChannel
                                },{onlySelf: true});

                                this.selectParentChannel();
                            }
                        }
                    } else if(![AccountModuleId,LeadModuleId,OpportunityModuleId,VendorModuleId,TaskModuleId,LocationModuleId].includes(this.selectedModule?.objectId)) {
                        if (mainModule?.templateId > 0) {
                            this.assoTemplates = resp.templates?.filter(x => x.isActive == true || x.id == mainModule?.templateId) ?? [];
                        }
                        else {
                            this.assoTemplates = resp.templates?.filter(x => x.isActive == true);
                        }
                        this.assoTemplates = this.assoTemplates.map(x => { x.objectId = resp.configuration?.objectId; return x; });
                    }
                },
                error => {
                    this.appMainService.isHideSpinner('getTemplateList');
                });
            }
        }
    }

    getAccountChannels(): void {
        this.appMainService.isShowSpinner('getChannel');
        this.sharedChannelService.getChannels(AccountModuleId)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
            {
                next: (response) => {
                    const channels = response || [];
                    this.accountChannels = this.permissionService.filterChannelsByPermissions(channels,ObjectNames.ACCOUNT);
                    this.accountChannelsIsActive = this.accountChannels;
                    this.appMainService.isHideSpinner('getChannel');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getChannel');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
                    });

                },
                complete: () => {
                    //this.getChannelStage(this.selectedChannelN?.id);
                },
            });
    }

    //#endregion

    //#region ***Rules and Conditions***
    //Condition Adding
    addConditionGroup(type: WorkflowModelsNS.WorkflowActionType){

        const constionRefId: number = this.conditionGroup.length>0 ? this.conditionGroup[0].id + 1 : 1;

        const condtion:  WorkflowModelsNS.WorkflowAddedEditConditionGroup = {
            id: constionRefId,
            conditionId: 0,
            statusId: 1,
            type: type,
            validData: false,
            errorMsg: "",
            savedSearchId: 0,
            isCombinational: false,
            ruleCombination: "",
            ruleData: [],
            instantActions: {
                id: 0,
                workflowConditionId: 0,
                workflowActionType: WorkflowModelsNS.OccurrenceTypeEnum.INSTANT,
                order: 1,
                statusId: 1,
                occurrenceType: WorkflowModelsNS.OccurrenceTypeEnum.INSTANT,
                dateTimeFieldName: 'ExecutionDateTime',
                executionOrders: ParseHelper.DeepCopy(WorkflowModelsNS.WorkflowActionDefaultOrders),
                workflowActionTasks: [],
                workflowActionEmails: [],
                workflowActionUpdateFields: [],
                workflowActionCreateRecords: [],
                workflowActionUpdateRecords: [],
                workflowActionConvertToInvoices: [],
                workflowActionDeleteRecords: [],
                workflowActionApprovals: [],
            },
            timeDependentActions: []
        }

        if(this.conditionGroup.length>0){
            this.conditionGroup.unshift(condtion)
        }else{
            this.conditionGroup.push(condtion)
        }
    }

    clearConditions(){
        this.conditionGroup.filter(addedCondition => addedCondition.conditionId>0).map(addedCondition=>{
            this.removeCondition(addedCondition);
        });

        const conditionGroup = ParseHelper.DeepCopy(this.conditionGroup);
        conditionGroup.map(addedCondition=>{
            this.removeCondition(addedCondition);
        });
    }

    removeCondition(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        if(addedCondition.conditionId>0){
            addedCondition.statusId = 3;
        }else{
            let i = this.conditionGroup.findIndex(c=>c.id==addedCondition.id);

            if(i>=0)
            this.conditionGroup.splice(i,1);
        }
    }

    validateCondtions(showMessage: boolean = false){
        this.conditionGroup.map(addedCondition=>{

            let haveAnyAction: boolean = false;

            haveAnyAction = !!(addedCondition.instantActions.workflowActionTasks?.length>0 || addedCondition.instantActions.workflowActionEmails?.length);

            if(!haveAnyAction && addedCondition.timeDependentActions.length>0){
                for(let i=0; i < addedCondition.timeDependentActions.length; i++){
                    haveAnyAction = !!(addedCondition.timeDependentActions[i].workflowActionTasks?.length>0 || addedCondition.timeDependentActions[i].workflowActionEmails?.length);
                    if(haveAnyAction)break;
                }
            }

            addedCondition.errorMsg = "";

            // if(!haveAnyAction && showMessage){
            //     addedCondition.errorMsg = WorkflowMessages.noActionAdded;
            // }

            if((addedCondition.ruleData?.length??0)==0 && showMessage){
                addedCondition.errorMsg = WorkflowMessages.noRulesAdded;
            }

            const addedRules = addedCondition.ruleData?.length||0;

            addedCondition.validData = !!(addedRules>0 || addedCondition?.statusId!=Status.Active);
        })
    }

    newConditionRule(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        if(addedCondition.type=='manual' || addedCondition?.ruleData?.length > 0){
            this.newParentRule(addedCondition);
        }else{
            this.newSavedSearchRule(addedCondition);
        }
    }

    newSavedSearchRule(s){
        this.conditionTemp = ParseHelper.DeepCopy(s);
        this.displaySavedSearchRule = true;
    }

    closeSavedSearchRulesDialog(){
        this.displaySavedSearchRule = false;
    }

    newParentRule(s) {
        this.manualRuleIndex = 0;
        this.manualRuleHeader = this.manualRuleIndex == 0 ? 'Add Rule' : 'Add Dependent Module';
        this.conditionTemp = ParseHelper.DeepCopy(s);
        this.ruleData = ParseHelper.DeepCopy(s.ruleData);
        this.lastRuleValues = {
            ...this.lastRuleValues,
            selectedFilter: null,
            selectedOperator: null,
            selectedValue: null,
            selectedValue2: null,
            selectedChoice:  this.ruleData.length>1 ? this.ruleData[1].choice : { id: 1, name: "And" },
            compareWithField: false,
            comparisonCriteria: null,
            comparisonCriteriaLabel: null,
            comparisonCriteriaParentLabel: null,
            isCustomComparisonCriteria: false,
            comparisonCriteriaObject: null,
            customAttributeObjectId: null,
            comparisonCustomAttributeObjectId: null
        };
        this.lastAssocRuleValues = {
            ...this.lastAssocRuleValues,
            selectedFilter: null,
            selectedOperator: null,
            selectedValue: null,
            selectedValue2: null,
            selectedChoice: this.ruleData.length>1 ? this.ruleData[1].choice : { id: 1, name: "And" },
            compareWithField: false,
            comparisonCriteria: null,
            comparisonCriteriaLabel: null,
            comparisonCriteriaParentLabel: null,
            isCustomComparisonCriteria: false,
            comparisonCriteriaObject: null,
            customAttributeObjectId: null,
            comparisonCustomAttributeObjectId: null
        };
        this.displayParentNewRule = true;
    }

    removeRule(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup,ruleData: any[], ruleDetails: {rule: any, index: number}){

        const checkActions = this.checkTransactionActions(addedCondition,ruleDetails.rule,'deletable');
        if(checkActions) return true;

        ruleData.splice(ruleDetails.index,1);
        this.setCanEdit(ruleData);
        this.ruleData = ruleData;

        const selectedCondtion = this.conditionGroup.find(s=> s.id === addedCondition.id);

        if( selectedCondtion.type != 'manual'){
            selectedCondtion.type = 'manual';
            selectedCondtion.savedSearchId = 0;
        }

        const activeModules = this.workflowActiveModuleActionsPipe.transform(this.actionModules,addedCondition.ruleData,this.workflowDetailsForm.getRawValue().selectedModule?.objectId)||[];
        const exist = activeModules.find(a=> a.objectId==this.selectedActionModule.objectId);
        if(!exist){
            this.selectedActionModule = activeModules[0]||null;
            this.selectActionModule();
        }
    }

    checkTransactionActions(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, rule: SavedSearchNS.IRuleList, type: 'deletable'|'editable' = 'deletable'){
        let actionExist: boolean = false;
        if(addedCondition && rule?.filter?.field?.toLowerCase()=='trans_transactiontype' && ['HasValue','IsEqualTo'].includes(rule?.operator?.name)){
            const addedTransactionModules =( rule?.operator?.name=='IsEqualTo' && rule?.value?.id) ? [rule?.value?.id] : [];
            let actionList = this.actionModules.filter(a=> addedTransactionModules.includes(a.transactionId)).map(a=> a.objectId);

            if(rule?.operator?.name=='HasValue'){
                actionList = this.actionModules.filter(a=> a.objectId!=this.selectedModule?.objectId).map(a=> a.objectId);
            }

            const actionCheckList = ['workflowActionUpdateFields','workflowActionUpdateRecords','workflowActionConvertToInvoices'];

            actionCheckList.map(actionName=>{
                const checkInstantAction = addedCondition?.instantActions?.[actionName] ? addedCondition?.instantActions?.[actionName].filter(a=> actionList.includes(a.objectId)) : [];
                const checkTimeAction = addedCondition?.timeDependentActions?.[actionName] ? addedCondition?.timeDependentActions?.[actionName].filter(a=> actionList.includes(a.objectId)) : [];
                actionExist = !actionExist ? (checkInstantAction?.length || checkTimeAction?.length) : actionExist;
            });

            if(actionExist){
                this.messageService.add({ severity: WorkflowMessages.warning.toLowerCase(), summary: `This rule is not ${type}`, detail: 'Some transaction related actions added, please remove those actions first.' });
            }
        }

        return actionExist
    }

    editRule(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup,  ruleDetails: {rule: any, index: number}){
        const checkActions = this.checkTransactionActions(addedCondition,ruleDetails.rule,'editable');
        if(checkActions) return true;

        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.ruleData = ParseHelper.DeepCopy(addedCondition.ruleData);
        this.selectedEditedRule = ParseHelper.DeepCopy(ruleDetails.rule);
        this.selectedRuleIndex = ruleDetails.index;
        addedCondition['editedRuleData'] = null;
        this.displayEditRule = true;
    }

    saveRuleCombination(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, data: {isCombinational: boolean, ruleCombination: string}){
        addedCondition.isCombinational = data.isCombinational;
        addedCondition.ruleCombination = data.ruleCombination;
    }

    cancelEditRule(){
        this.displayEditRule = false;
    }

    cancelParentRuleDialog(){
        this.ruleList = [];
        this.assocRuleList = [];
        this.selectedAssoModule = null;
        this.displayParentNewRule = false;
    }

    openPreviewSavedSearch(ruleData: SavedSearchNS.IRuleList[], addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup) {
        //Call Preview
        this.previewSavedSearch('Preview', ruleData, addedCondition);
    }

    //Cancel Preview
    onSSPreviewCancel(): void {
        this.ssPreviewDataList = [];
        this.ssPreviewColumnList = [];
        this.displaySSPreviewDataList = false;
    }

    validateRuleError(){
        const invalidField = document.querySelector('.saved-search-rule-error');
        const classList = invalidField?.classList ? Array.from(invalidField.classList) : [];
        let valid: boolean = true;
        if(classList?.length>0){
            valid = false;
            this.manualRuleIndex = classList.includes('main-module-rule-error') ? 0 : 1;
        }

        return valid;
    }

    //Add To RuleData List
    saveRule(isMainModule: boolean, selectedEditRule: SavedSearchNS.IRuleList) {

            if(!this.validateRuleError()){
                return;
            }

            let lastSelectedChoice: any = { id: 1, name: "And" };

            //Parent Rules
            let parentRule = this.ruleData.filter(ele => ele.isMainModule == true);
            //Associate Rules
            let associateRule = this.ruleData.filter(ele => ele.isMainModule == false);
            if (this.ruleList.length > 0) {
                for (let s of this.ruleList) {
                    if(s?.filter?.parent || s?.filter?.children){
                        s.filter.parent = null;
                        s.filter.children = null;
                    }
                    s.valueLists = [];
                    s.filtersDD = [];
                    s.treeValueLists = [];
                    s.filtersDDTree = [];
                    s.ruleNo = !s?.ruleNo ? savedSearchRuleNo([...parentRule,...associateRule]) : s.ruleNo;
                    parentRule.push(s);
                }
                lastSelectedChoice = this.ruleList[(this.ruleList.length-1)].choice||lastSelectedChoice;
            }

            if (this.assocRuleList.length > 0) {
                for (let s of this.assocRuleList) {
                    if(s?.filter?.parent || s?.filter?.children){
                        s.filter.parent = null;
                        s.filter.children = null;
                    }
                    s.valueLists = [];
                    s.filtersDD = [];
                    s.treeValueLists = [];
                    s.filtersDDTree = [];
                    s.ruleNo = !s?.ruleNo ? savedSearchRuleNo([...parentRule,...associateRule]) : s.ruleNo;
                    associateRule.push(s);
                }
                lastSelectedChoice = this.assocRuleList[(this.assocRuleList.length-1)].choice||lastSelectedChoice;
            }

            const parentRuleNo = savedSearchRuleNo([...parentRule,...associateRule]);
            const lastMainRule = this.setLastRuleValue(this.lastRuleValues,true,parentRuleNo);

            if(lastMainRule){
                parentRule.push(lastMainRule);
                lastSelectedChoice = lastMainRule.choice||lastSelectedChoice;
            }

            const associtateRuleNo = savedSearchRuleNo([...parentRule,...associateRule]);
            const lastAssocRule = this.setLastRuleValue(this.lastAssocRuleValues,false,associtateRuleNo);

            if(lastAssocRule){
                associateRule.push(lastAssocRule);
                lastSelectedChoice = lastAssocRule.choice||lastSelectedChoice;
            }

            // associateRule = associateRule?.sort((a, b) => b.subModule?.name > a.subModule?.name ? -1 : 1) ?? associateRule;
            this.ruleData = [];
            for (let a of parentRule) {
                a.choice = a.choice ?? { id: 1, name: "And" };
                this.ruleData.push(a);
            }
            for (let b of associateRule) {
                b.choice = b.choice ?? { id: 1, name: "And" };
                this.ruleData.push(b);
            }

            for (let rule of this.ruleData) {
                // rule.choice = lastSelectedChoice;
                rule = getSavedSearchTreeRuleValues(rule);
            }

            if (this.ruleData.length > 0) {
                this.ruleData[0].choice = null;
            }

            this.ruleList = [];
            this.assocRuleList = [];
            //Country,State,City rule edit enable/disable
            this.setCanEdit(this.ruleData);
            const selectedCondtion = this.conditionGroup.find(s=> s.id === this.conditionTemp.id);

            if(selectedCondtion){
                selectedCondtion.type = 'manual';
                selectedCondtion.ruleData = ParseHelper.DeepCopy(this.ruleData);
                this.ruleData = [];
            }


        this.displayParentNewRule = false;
    }

    updateEditedRule(conditionId: number = 0){
        if(!this.validateRuleError()){
            return;
        }

        conditionId = conditionId>0 ? conditionId : this.conditionTemp.id;
        const selectedCondtion = this.conditionGroup.find(s=> s.id === conditionId);
        if( selectedCondtion.type != 'manual'){
            selectedCondtion.type = 'manual';
            selectedCondtion.savedSearchId = 0;
        }
        if(selectedCondtion.ruleData.length>this.selectedRuleIndex){
            const editedRuleData = this.selectedEditedRule?.isMainModule ? this.setEditedRuleValue(this.lastRuleValues) : this.setEditedRuleValue(this.lastAssocRuleValues);
            if(editedRuleData){
                selectedCondtion.ruleData[this.selectedRuleIndex] = editedRuleData;
                selectedCondtion['editedRuleData'] = editedRuleData;

                // selectedCondtion.ruleData.map(rule=>{
                //     rule.choice = selectedCondtion.ruleData[this.selectedRuleIndex].choice
                // })

                selectedCondtion.ruleData[0].choice = null;
                this.setCanEdit(selectedCondtion.ruleData);
                this.displayEditRule = false;
            }
        }
    }

    updateRuleChoice(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, data: {ruleIndex: number, choice: SavedSearchNS.IChoice}){
        addedCondition.ruleData[data.ruleIndex].choice = data.choice;
    }

    setLastRuleValue(lastRuleValue: any, isMainModule, ruleNo: string){
        if (lastRuleValue.selectedFilter && ((lastRuleValue.selectedValue || lastRuleValue.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value') || (['Money','Number','Decimal'].includes(lastRuleValue.selectedFilter?.fieldDataType) && lastRuleValue.selectedValue!==null) ||
                (lastRuleValue.selectedFilter?.fieldDataType == 'DateTime' && lastRuleValue.selectedDataTypeWithOperator?.Operator == 'Is' && lastRuleValue.selectedValue2))) {
            let eachRule: SavedSearchNS.IRuleList = {
                id: 0,
                ruleNo: ruleNo,
                module: isMainModule == true ? this.workflowDetailsForm.getRawValue().selectedModule : this.selectedAssoModule,
                subModule: this.selectedAssoModule,
                template: isMainModule == true ? this.workflowDetailsForm.getRawValue().selectedChannel : this.selectedAssoTemplate,
                filter: lastRuleValue.selectedFilter,
                operator: lastRuleValue.selectedOperator,
                value: lastRuleValue.selectedValue,
                value2: lastRuleValue.selectedValue2,
                choice: lastRuleValue.selectedChoice,
                isMainModule: isMainModule,
                dataTypeWithOperator: lastRuleValue.selectedDataTypeWithOperator,
                valueLists: [],
                treeValueLists: [],
                objectId: isMainModule == true ? this.workflowDetailsForm.getRawValue().selectedModule?.objectId : this.selectedAssoModule?.objectId,
                objectName: isMainModule == true ? this.workflowDetailsForm.getRawValue().selectedModule?.name : this.selectedAssoModule?.name,
                valueRefId: [],
                groupLabel: lastRuleValue.selectedGroupLabel,
                groupChildren: lastRuleValue.selectedGroupChildren,
                group: lastRuleValue.selectedGroup,
                filtersDD: [],
                canEdit: true,
                accountChannel: this.workflowDetailsForm.getRawValue().selectedAccountChannel,
                compareWithField: lastRuleValue?.compareWithField||false,
                comparisonCriteria: lastRuleValue?.comparisonCriteria||null,
                comparisonCriteriaLabel: lastRuleValue?.comparisonCriteriaLabel||null,
                comparisonCriteriaParentLabel: lastRuleValue?.comparisonCriteriaParentLabel||null,
                isCustomComparisonCriteria: lastRuleValue?.isCustomComparisonCriteria||false,
                comparisonCriteriaObject: isMainModule == true ? this.workflowDetailsForm.getRawValue().selectedModule?.name : this.selectedAssoModule?.name,
                customAttributeObjectId: lastRuleValue?.customAttributeObjectId||null,
                comparisonCustomAttributeObjectId: lastRuleValue?.comparisonCustomAttributeObjectId||null,
            }
            if(eachRule?.filter?.parent || eachRule?.filter?.children){
                eachRule.filter.parent = null;
                eachRule.filter.children = null
            }

            return eachRule;
        }

        return null;
    }

    setEditedRuleValue(lastRuleValue: any){
        if (lastRuleValue.selectedFilter && ((lastRuleValue.selectedValue || lastRuleValue.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value') || (['Money','Number','Decimal'].includes(lastRuleValue.selectedFilter?.fieldDataType) && lastRuleValue.selectedValue!==null) ||
                (lastRuleValue.selectedFilter?.fieldDataType == 'DateTime' && lastRuleValue.selectedDataTypeWithOperator?.Operator == 'Is' && lastRuleValue.selectedValue2))) {
            let eachRule: SavedSearchNS.IRuleList = {
                ...this.selectedEditedRule,
                filter: lastRuleValue.selectedFilter,
                operator: lastRuleValue.selectedOperator,
                value: lastRuleValue.selectedValue,
                value2: lastRuleValue.selectedValue2,
                choice: lastRuleValue.selectedChoice,
                dataTypeWithOperator: lastRuleValue.selectedDataTypeWithOperator,
                valueLists: [],
                treeValueLists: [],
                valueRefId: [],
                groupLabel: lastRuleValue.selectedGroupLabel,
                groupChildren: lastRuleValue.selectedGroupChildren,
                group: lastRuleValue.selectedGroup,
                filtersDD: [],
                compareWithField: lastRuleValue?.compareWithField||false,
                comparisonCriteria: lastRuleValue?.comparisonCriteria||null,
                comparisonCriteriaLabel: lastRuleValue?.comparisonCriteriaLabel||null,
                comparisonCriteriaParentLabel: lastRuleValue?.comparisonCriteriaParentLabel||null,
                isCustomComparisonCriteria: lastRuleValue?.isCustomComparisonCriteria||false,
                customAttributeObjectId: lastRuleValue?.customAttributeObjectId||null,
                comparisonCustomAttributeObjectId: lastRuleValue?.comparisonCustomAttributeObjectId||null,
            }
            eachRule = getSavedSearchTreeRuleValues(eachRule);
            if(eachRule?.filter?.parent || eachRule?.filter?.children){
                eachRule.filter.parent = null;
                eachRule.filter.children = null
            }

            return eachRule;
        }

        return null;
    }

    addSavedSearchRules(savedSearchDetails: {selectedSavedSearch: any, addedRules: SavedSearchNS.IRuleList[], ruleCombination: string}){
        const selectedCondtion = this.conditionGroup.find(s=> s.id === this.conditionTemp.id);

        if(selectedCondtion && savedSearchDetails.selectedSavedSearch && savedSearchDetails.addedRules.length>0){
            selectedCondtion.savedSearchId = savedSearchDetails.selectedSavedSearch.id;
            selectedCondtion.ruleData = ParseHelper.DeepCopy(savedSearchDetails.addedRules);
            selectedCondtion.isCombinational = !!(savedSearchDetails.ruleCombination);
            selectedCondtion.ruleCombination = savedSearchDetails.ruleCombination;
        }
    }

    //Country,State,City rule edit enable/disable
    setCanEdit(ruleData: SavedSearchNS.IRuleList[]) {
        //Set Rule Edit Enable/Disable
        for (let rule of ruleData) {
            rule.canEdit = this.canRuleEdit(rule.filter,ruleData);
        }
        //Remove first choice
        if (ruleData?.length > 0) {
            ruleData[0].choice = null;
        }
    }

    canRuleEdit(filter: SavedSearchNS.IField, ruleData: SavedSearchNS.IRuleList[]): boolean {
        let canRuleEdit = true;
        if (filter &&
            (filter?.field?.toLowerCase() == "country" ||
                filter?.field?.toLowerCase() == "state" ||
                filter?.field?.toLowerCase() == "city")) {

            const country = ruleData.find(x => x.filter.field?.toLowerCase() == "country");
            const state = ruleData.find(x => x.filter.field?.toLowerCase() == "state");
            const city = ruleData.find(x => x.filter.field?.toLowerCase() == "city");
            //Country
            if (filter?.field?.toLowerCase() == "country") {
                if (state) {
                    canRuleEdit = false;
                }
            }
            //State
            else if (filter?.field?.toLowerCase() == "state") {
                if (city) {
                    canRuleEdit = false;
                }
            }
            //City
            else if (filter?.field?.toLowerCase() == "city") {
                canRuleEdit = true;
            }

        }

        if (filter && ['trans_location_country','trans_location_state'].includes(filter?.field?.toLowerCase())) {
            const trans_location_state = ruleData.find(x => x.filter.field?.toLowerCase() == "trans_location_state");
            const trans_location_city = ruleData.find(x => x.filter.field?.toLowerCase() == "trans_location_city");

            if ((filter?.field?.toLowerCase() == "trans_location_country" && trans_location_state)
                ||(filter?.field?.toLowerCase() == "trans_location_state" && trans_location_city)) {
                canRuleEdit = false;
            }
        }

        if (filter && ['opportunity_country','opportunity_state'].includes(filter?.field?.toLowerCase())) {
            const opportunity_state = ruleData.find(x => x.filter.field?.toLowerCase() == "opportunity_state");
            const opportunity_city = ruleData.find(x => x.filter.field?.toLowerCase() == "opportunity_city");

            if ((filter?.field?.toLowerCase() == "opportunity_country" && opportunity_state)
                ||(filter?.field?.toLowerCase() == "opportunity_state" && opportunity_city)) {
                canRuleEdit = false;
            }
        }

        return canRuleEdit;
    }

    addTriggerTime(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.selectedTriggerTime = null;
        this.timeDependentIndex = -1;
        this.displayAddTriggerTime = true;
    }

    editTriggerTime(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, selectedTriggerTime: WorkflowModelsNS.WorkflowTimeDependentActions, i: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.timeDependentIndex = i;
        this.selectedTriggerTime = ParseHelper.DeepCopy(selectedTriggerTime);
        this.displayAddTriggerTime = true;
    }

    saveTriggerTime(timeDependentValue: WorkflowModelsNS.WorkflowTimeDependentActions){

        const selectedCondtionIndex = this.conditionGroup.findIndex(s=> s.id === this.conditionTemp.id);

        if(timeDependentValue && selectedCondtionIndex>=0){

            if(this.selectedTriggerTime && this.timeDependentIndex > -1 && this.conditionGroup[selectedCondtionIndex].timeDependentActions.length >  this.timeDependentIndex){
                const timeDependentAction: WorkflowModelsNS.WorkflowTimeDependentActions = {
                    ...this.selectedTriggerTime,
                    ...timeDependentValue
                }

                this.conditionGroup[selectedCondtionIndex].timeDependentActions[this.timeDependentIndex] = timeDependentAction;
                this.timeDependentIndex = -1;
                this.selectedTriggerTime = null;
            }else{
                const timeDependentAction: WorkflowModelsNS.WorkflowTimeDependentActions = {
                    ...timeDependentValue,
                    id: 0,
                    statusId: 1,
                    executionOrders: ParseHelper.DeepCopy(WorkflowModelsNS.WorkflowActionDefaultOrders),
                    workflowActionTasks: [],
                    workflowActionEmails: [],
                    workflowActionUpdateFields: [],
                    workflowActionCreateRecords: [],
                    workflowActionUpdateRecords: [],
                    workflowActionConvertToInvoices: [],
                    workflowActionDeleteRecords: [],
                    workflowActionApprovals: []
                }

                this.conditionGroup[selectedCondtionIndex].timeDependentActions.push(timeDependentAction);
            }


            this.displayAddTriggerTime = false;
        }
    }

    removeTriggerTime(timeDependentActions: WorkflowModelsNS.WorkflowTimeDependentActions[],i: number){
        timeDependentActions.splice(i, 1);
    }

    //#endregion

    //Instant Task CRUD

    saveActionTask(taskDetails: WorkflowModelsNS.WorkflowAddEditActionTask){
        const selectedCondtionIndex = this.conditionGroup.findIndex(s=> s.id === this.conditionTemp.id);

        if(selectedCondtionIndex>=0 && this.selectedActionTask && this.selectedTaskIndex > -1){
            this.updateEditedTask(taskDetails,this.conditionGroup[selectedCondtionIndex])
        }else{
            if(selectedCondtionIndex>=0 && this.actionType=='instant'){
                this.addInstantTask(taskDetails,this.conditionGroup[selectedCondtionIndex])
            }else if(selectedCondtionIndex>=0 && this.conditionGroup[selectedCondtionIndex]?.timeDependentActions?.length>0 && this.actionType=='timedependent'){
                this.addTimeDependentTask(taskDetails,this.conditionGroup[selectedCondtionIndex])
            }
        }

    }

    addInstantTask(taskDetails: WorkflowModelsNS.WorkflowAddEditActionTask, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        taskDetails.workflowActionId = addedCondition?.instantActions?.id||0;

        if(addedCondition?.instantActions?.workflowActionTasks?.length>0){
            addedCondition.instantActions.workflowActionTasks.unshift(taskDetails)
        }else{
            addedCondition.instantActions.workflowActionTasks = [];
            addedCondition.instantActions.workflowActionTasks.push(taskDetails);
            this.addNewActionOrder(addedCondition.instantActions,'workflowActionTasks');
        }
    }

    addTimeDependentTask(taskDetails: WorkflowModelsNS.WorkflowAddEditActionTask, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        const workflowList = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionTasks;

        taskDetails.workflowActionId = addedCondition.timeDependentActions[this.timeDependentIndex]?.id||0;

        if(workflowList?.length>0){
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionTasks.unshift(taskDetails)
        }else{
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionTasks = [];
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionTasks.push(taskDetails)
            this.addNewActionOrder(addedCondition.timeDependentActions[this.timeDependentIndex],'workflowActionTasks');
        }
    }

    updateEditedTask(taskDetails: WorkflowModelsNS.WorkflowAddEditActionTask,  addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        if(this.actionType=='instant'){
            if(addedCondition?.instantActions?.workflowActionTasks?.length > this.selectedTaskIndex){
                addedCondition.instantActions.workflowActionTasks[this.selectedTaskIndex] = taskDetails;
            }
        }else if(addedCondition.timeDependentActions?.length > this.timeDependentIndex){
            if(addedCondition.timeDependentActions[this.timeDependentIndex]?.workflowActionTasks?.length > this.selectedTaskIndex){
                addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionTasks[this.selectedTaskIndex] = taskDetails;
            }
        }

        this.selectedActionTask = null;
        this.selectedTaskIndex = -1;
        this.timeDependentIndex = -1;
    }

    openTaskEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, taskDetails: WorkflowModelsNS.WorkflowAddEditActionTask, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;

        this.selectedActionTask = ParseHelper.DeepCopy(taskDetails);
        this.selectedTaskIndex = index;
        this.displayAddTask = true;
    }

    removeInstantTask(taskList: WorkflowModelsNS.WorkflowAddEditActionTask[], index: number, actionDetails: any){
        taskList.splice(index, 1);
        this.removeActionOrder(actionDetails,'workflowActionTasks');
    }

    //Email Action

    saveActionEmail(emailDetails: WorkflowModelsNS.WorkflowAddEditActionEmail){
        const selectedCondtionIndex = this.conditionGroup.findIndex(s=> s.id === this.conditionTemp.id);

        if(selectedCondtionIndex>=0 && this.selectedActionEmail && this.selectedEmailIndex > -1){
            this.updateEditedEmail(emailDetails,this.conditionGroup[selectedCondtionIndex])
        }else{
            if(selectedCondtionIndex>=0 && this.actionType=='instant'){
                this.addInstantEmail(emailDetails,this.conditionGroup[selectedCondtionIndex])
            }else if(selectedCondtionIndex>=0 && this.conditionGroup[selectedCondtionIndex]?.timeDependentActions?.length>0 && this.actionType=='timedependent'){
                this.addTimeDependentEmail(emailDetails,this.conditionGroup[selectedCondtionIndex])
            }
        }

    }

    addInstantEmail(emailDetails: WorkflowModelsNS.WorkflowAddEditActionEmail, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        emailDetails.workflowActionId = addedCondition?.instantActions?.id||0;

        if(addedCondition?.instantActions?.workflowActionEmails?.length>0){
            addedCondition.instantActions.workflowActionEmails.unshift(emailDetails)
        }else{
            addedCondition.instantActions.workflowActionEmails = [];
            addedCondition.instantActions.workflowActionEmails.push(emailDetails);
            this.addNewActionOrder(addedCondition.instantActions,'workflowActionEmails');
        }
    }

    addTimeDependentEmail(emailDetails: WorkflowModelsNS.WorkflowAddEditActionEmail, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        const workflowList = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionEmails;
        emailDetails.workflowActionId = addedCondition.timeDependentActions[this.timeDependentIndex]?.id||0;

        if(workflowList?.length>0){
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionEmails.unshift(emailDetails)
        }else{
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionEmails = [];
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionEmails.push(emailDetails);
            this.addNewActionOrder(addedCondition.timeDependentActions[this.timeDependentIndex],'workflowActionEmails');
        }
    }

    updateEditedEmail(emailDetails: WorkflowModelsNS.WorkflowAddEditActionEmail,  addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        if(this.actionType=='instant'){
            if(addedCondition?.instantActions?.workflowActionEmails?.length > this.selectedEmailIndex){
                addedCondition.instantActions.workflowActionEmails[this.selectedEmailIndex] = emailDetails;
            }
        }else if(addedCondition.timeDependentActions?.length > this.timeDependentIndex){
            if(addedCondition.timeDependentActions[this.timeDependentIndex]?.workflowActionEmails?.length > this.selectedEmailIndex){
                addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionEmails[this.selectedEmailIndex] = emailDetails;
            }
        }

        this.selectedActionEmail = null;
        this.selectedEmailIndex = -1;
        this.timeDependentIndex = -1;
    }

    openEmailEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, emailDetails: WorkflowModelsNS.WorkflowAddEditActionEmail, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;
        this.notificationType = emailDetails?.notificationType||WorkflowModelsNS.WorkflowNotificationTypeEnum.EMAIL;
        this.selectedActionEmail = ParseHelper.DeepCopy(emailDetails);
        this.selectedActionModule = this.actionModules.find(m=> m.objectId==emailDetails?.objectId)||null;
        this.selectActionModule();
        this.selectedEmailIndex = index;
        this.displayAddEmailAlert = true;
    }

    removeEmail(emailList: WorkflowModelsNS.WorkflowAddEditActionEmail[], index: number, actionDetails: any){
        emailList.splice(index, 1);
        this.removeActionOrder(actionDetails,'workflowActionEmails');
    }

    //Update Field Action

    saveActionField(fieldDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateFields){
        const selectedCondtionIndex = this.conditionGroup.findIndex(s=> s.id === this.conditionTemp.id);

        if(selectedCondtionIndex>=0 && this.selectedActionField && this.selectedFieldIndex > -1){
            this.updateEditedField(fieldDetails,this.conditionGroup[selectedCondtionIndex])
        }else{
            if(selectedCondtionIndex>=0 && this.actionType=='instant'){
                this.addInstantField(fieldDetails,this.conditionGroup[selectedCondtionIndex])
            }else if(selectedCondtionIndex>=0 && this.conditionGroup[selectedCondtionIndex]?.timeDependentActions?.length>0 && this.actionType=='timedependent'){
                this.addTimeDependentField(fieldDetails,this.conditionGroup[selectedCondtionIndex])
            }
        }

    }

    addInstantField(fieldDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateFields, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        fieldDetails.workflowActionId = addedCondition?.instantActions?.id||0;

        if(addedCondition?.instantActions?.workflowActionUpdateFields?.length>0){
            addedCondition.instantActions.workflowActionUpdateFields.unshift(fieldDetails)
        }else{
            addedCondition.instantActions.workflowActionUpdateFields = [];
            addedCondition.instantActions.workflowActionUpdateFields.push(fieldDetails);
            this.addNewActionOrder(addedCondition.instantActions,'workflowActionUpdateFields');
        }
    }

    addTimeDependentField(fieldDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateFields, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        const workflowList = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateFields;
        fieldDetails.workflowActionId = addedCondition.timeDependentActions[this.timeDependentIndex]?.id||0;

        if(workflowList?.length>0){
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateFields.unshift(fieldDetails)
        }else{
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateFields = [];
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateFields.push(fieldDetails);
            this.addNewActionOrder(addedCondition.timeDependentActions[this.timeDependentIndex],'workflowActionUpdateFields');
        }
    }

    updateEditedField(fieldDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateFields,  addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        if(this.actionType=='instant'){
            if(addedCondition?.instantActions?.workflowActionUpdateFields?.length > this.selectedFieldIndex){
                addedCondition.instantActions.workflowActionUpdateFields[this.selectedFieldIndex] = fieldDetails;
            }
        }else if(addedCondition.timeDependentActions?.length > this.timeDependentIndex){
            if(addedCondition.timeDependentActions[this.timeDependentIndex]?.workflowActionUpdateFields?.length > this.selectedFieldIndex){
                addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateFields[this.selectedFieldIndex] = fieldDetails;
            }
        }

        this.selectedActionField = null;
        this.selectedFieldIndex = -1;
        this.timeDependentIndex = -1;
    }

    openFieldEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, fieldDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateFields, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;

        this.selectedActionField = ParseHelper.DeepCopy(fieldDetails);
        this.selectedActionModule = this.actionModules.find(m=> m.objectId==fieldDetails?.objectId)||null;
        this.selectedFieldIndex = index;
        this.selectActionModule();
        this.checkAddedUpdateField(fieldDetails.fieldName);
        this.displayUpdateField = true;
    }

    removeField(fieldList: WorkflowModelsNS.WorkflowAddEditActionUpdateFields[], index: number, actionDetails: any){
        fieldList.splice(index, 1);
        this.removeActionOrder(actionDetails,'workflowActionUpdateFields');
    }

    //Action Methods

    //Create Record Action

    savedCreateRecord(recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecord){
        const selectedCondtionIndex = this.conditionGroup.findIndex(s=> s.id === this.conditionTemp.id);

        if(selectedCondtionIndex>=0 && this.selectedActionRecord && this.selectedRecordIndex > -1){
            this.updateEditedRecord(recordDetails,this.conditionGroup[selectedCondtionIndex])
        }else{
            if(selectedCondtionIndex>=0 && this.actionType=='instant'){
                this.addInstantCreateRecord(recordDetails,this.conditionGroup[selectedCondtionIndex])
            }else if(selectedCondtionIndex>=0 && this.conditionGroup[selectedCondtionIndex]?.timeDependentActions?.length>0 && this.actionType=='timedependent'){
                this.addTimeDependentRecord(recordDetails,this.conditionGroup[selectedCondtionIndex])
            }
        }

    }

    addInstantCreateRecord(recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecord, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        recordDetails.workflowActionId = addedCondition?.instantActions?.id||0;

        if(addedCondition?.instantActions?.workflowActionCreateRecords?.length>0){
            addedCondition.instantActions.workflowActionCreateRecords.unshift(recordDetails)
        }else{
            addedCondition.instantActions.workflowActionCreateRecords = [];
            addedCondition.instantActions.workflowActionCreateRecords.push(recordDetails);
            this.addNewActionOrder(addedCondition.instantActions,'workflowActionCreateRecords');
        }
    }

    addTimeDependentRecord(recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecord, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        const workflowList = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionCreateRecords;
        recordDetails.workflowActionId = addedCondition.timeDependentActions[this.timeDependentIndex]?.id||0;

        if(workflowList?.length>0){
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionCreateRecords.unshift(recordDetails)
        }else{
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionCreateRecords = [];
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionCreateRecords.push(recordDetails);
            this.addNewActionOrder(addedCondition.timeDependentActions[this.timeDependentIndex],'workflowActionCreateRecords');
        }
    }

    updateEditedRecord(recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecord, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        if(this.actionType=='instant'){
            if(addedCondition?.instantActions?.workflowActionCreateRecords?.length > this.selectedRecordIndex){
                addedCondition.instantActions.workflowActionCreateRecords[this.selectedRecordIndex] = recordDetails;
            }
        }else if(addedCondition.timeDependentActions?.length > this.timeDependentIndex){
            if(addedCondition.timeDependentActions[this.timeDependentIndex]?.workflowActionCreateRecords?.length > this.selectedRecordIndex){
                addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionCreateRecords[this.selectedRecordIndex] = recordDetails;
            }
        }

        this.selectedActionRecord = null;
        this.selectedRecordIndex = -1;
        this.timeDependentIndex = -1;
    }

    openCreateRecordEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecord, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;

        this.selectedActionRecord = ParseHelper.DeepCopy(recordDetails);
        this.selectedRecordIndex = index;
        this.displayCreateRecord = true;
    }

    removeCreateRecord(recordList: WorkflowModelsNS.WorkflowAddEditActionCreateRecord[], index: number, actionDetails: any){
        recordList.splice(index, 1);
        this.removeActionOrder(actionDetails,'workflowActionCreateRecords');
    }

    //Create Approvals

    savedApprovals(addedApprovals: WorkflowModelsNS.WorkflowAddEditActionApprovals[]){
        const selectedCondtionIndex = this.conditionGroup.findIndex(s=> s.id === this.conditionTemp.id);

        if(selectedCondtionIndex>=0 && this.actionType=='instant'){
            this.addInstantApprovals(addedApprovals,this.conditionGroup[selectedCondtionIndex])
        }else if(selectedCondtionIndex>=0 && this.conditionGroup[selectedCondtionIndex]?.timeDependentActions?.length>0 && this.actionType=='timedependent'){
            this.addTimeDependentApprovals(addedApprovals,this.conditionGroup[selectedCondtionIndex])
        }

        this.displayAddApproval = false;
    }

    addInstantApprovals(addedApprovals: WorkflowModelsNS.WorkflowAddEditActionApprovals[], addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        addedApprovals.map(approval=>{
            approval.workflowActionId = addedCondition?.instantActions?.id||0;
        });

        let addingNew: boolean = false;

        if(addedCondition?.instantActions?.workflowActionApprovals?.length>0){
            addedCondition.instantActions.workflowActionApprovals = addedCondition.instantActions.workflowActionApprovals.filter(approval=> approval.objectId != addedApprovals[0].objectId)
        }else{
            addedCondition.instantActions.workflowActionApprovals = [];
            addingNew = true;
        }

        addedCondition.instantActions.workflowActionApprovals = [...addedCondition.instantActions.workflowActionApprovals,...addedApprovals];

        if(addingNew){
            this.addNewActionOrder(addedCondition.instantActions,'workflowActionApprovals');
        }
    }

    addTimeDependentApprovals(addedApprovals: WorkflowModelsNS.WorkflowAddEditActionApprovals[], addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        const workflowList = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionApprovals;

        addedApprovals.map(approval=>{
            approval.workflowActionId = addedCondition.timeDependentActions[this.timeDependentIndex]?.id||0;
        });

        let addingNew: boolean = false;

        if(workflowList.length>0){
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionApprovals = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionApprovals.filter(approval=> approval.objectId != addedApprovals[0].objectId)
        }else{
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionApprovals = [];
            addingNew = true;
        }

        addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionApprovals = [...addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionApprovals,...addedApprovals];
        if(addingNew){
            this.addNewActionOrder(addedCondition.timeDependentActions[this.timeDependentIndex],'workflowActionApprovals');
        }
    }

    openApprovalEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, selectedApprovals: WorkflowModelsNS.WorkflowAddEditActionApprovals[]){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;
        this.selectedActionModule = this.actionModules.find(m=> m.objectId==selectedApprovals?.[0]?.objectId)||null;
        this.selectedActionApprovals = ParseHelper.DeepCopy(selectedApprovals);
        this.displayAddApproval = true;
    }

    removeApprovals(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, objectId: number, type: 'instant'|'timedependent', timeDependentIndex: number = -1){
        if(type=='instant'){
            const approvals = addedCondition.instantActions.workflowActionApprovals.filter(approval => approval.objectId !== objectId);
            addedCondition.instantActions.workflowActionApprovals = ParseHelper.DeepCopy(approvals);
            this.removeActionOrder(addedCondition.instantActions,'workflowActionApprovals');
        }else{
            const approvals = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionApprovals.filter(approval => approval.objectId !== objectId);
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionApprovals = ParseHelper.DeepCopy(approvals);
            this.removeActionOrder(addedCondition.timeDependentActions[this.timeDependentIndex],'workflowActionApprovals');
        }
    }

    //Create Update Action

    savedUpdateRecord(recordDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord){
        const selectedCondtionIndex = this.conditionGroup.findIndex(s=> s.id === this.conditionTemp.id);

        if(selectedCondtionIndex>=0 && this.selectedActionUpdateRecord && this.selectedUpdateRecordIndex > -1){
            this.updateEditedUpdateRecord(recordDetails,this.conditionGroup[selectedCondtionIndex])
        }else{
            if(selectedCondtionIndex>=0 && this.actionType=='instant'){
                this.addInstantUpdateCreateRecord(recordDetails,this.conditionGroup[selectedCondtionIndex])
            }else if(selectedCondtionIndex>=0 && this.conditionGroup[selectedCondtionIndex]?.timeDependentActions?.length>0 && this.actionType=='timedependent'){
                this.addTimeDependentUpdateRecord(recordDetails,this.conditionGroup[selectedCondtionIndex])
            }
        }

    }

    addInstantUpdateCreateRecord(recordDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        recordDetails.workflowActionId = addedCondition?.instantActions?.id||0;

        if(addedCondition?.instantActions?.workflowActionUpdateRecords?.length>0){
            addedCondition.instantActions.workflowActionUpdateRecords.unshift(recordDetails);
        }else{
            addedCondition.instantActions.workflowActionUpdateRecords = [];
            addedCondition.instantActions.workflowActionUpdateRecords.push(recordDetails);
            this.addNewActionOrder(addedCondition.instantActions,'workflowActionUpdateRecords');
        }
    }

    addTimeDependentUpdateRecord(recordDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        const workflowList = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateRecords;
        recordDetails.workflowActionId = addedCondition.timeDependentActions[this.timeDependentIndex]?.id||0;

        if(workflowList?.length>0){
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateRecords.unshift(recordDetails)
        }else{
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateRecords = [];
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateRecords.push(recordDetails);
            this.addNewActionOrder(addedCondition.timeDependentActions[this.timeDependentIndex],'workflowActionUpdateRecords');
        }
    }

    updateEditedUpdateRecord(recordDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        if(this.actionType=='instant'){
            if(addedCondition?.instantActions?.workflowActionUpdateRecords?.length > this.selectedUpdateRecordIndex){
                addedCondition.instantActions.workflowActionUpdateRecords[this.selectedUpdateRecordIndex] = recordDetails;
            }
        }else if(addedCondition.timeDependentActions?.length > this.timeDependentIndex){
            if(addedCondition.timeDependentActions[this.timeDependentIndex]?.workflowActionUpdateRecords?.length > this.selectedUpdateRecordIndex){
                addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionUpdateRecords[this.selectedUpdateRecordIndex] = recordDetails;
            }
        }

        this.selectedActionUpdateRecord = null;
        this.selectedUpdateRecordIndex = -1;
        this.timeDependentIndex = -1;
    }

    openUpdateRecordEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, recordDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;
        this.selectedActionUpdateRecord = ParseHelper.DeepCopy(recordDetails);
        this.selectedActionModule = this.actionModules.find(m=> m.objectId==recordDetails?.objectId)||null;
        this.selectActionModule();
        this.selectedUpdateRecordIndex = index;
        this.displayUpdateRecord = true;
    }

    removeUpdateRecord(recordList: WorkflowModelsNS.WorkflowAddEditActionUpdateRecord[], index: number, actionDetails: any){
        recordList.splice(index, 1);
        this.removeActionOrder(actionDetails,'workflowActionUpdateRecords');
    }

    //Create Convert Action

    saveConvertAction(conversionType: WorkflowModelsNS.WorkflowConversionTypeEnum = WorkflowModelsNS.WorkflowConversionTypeEnum.Invoice){
        const selectedCondtionIndex = this.conditionGroup.findIndex(s=> s.id === this.conditionTemp.id);
        const convertInvoice: WorkflowModelsNS.WorkflowAddEditActionConvertToInvoice = {
            id: 0,
            workflowActionId: 0,
            objectId: this.selectedActionModule.objectId,
            objectName: this.selectedActionModule.name,
            conversionType: conversionType,
            billStatus: false,
            statusId: Status.Active
        }

        if(selectedCondtionIndex>=0 && this.actionType=='instant'){
            this.addInvoiceConvertAction(convertInvoice,this.conditionGroup[selectedCondtionIndex])
        }else if(selectedCondtionIndex>=0 && this.conditionGroup[selectedCondtionIndex]?.timeDependentActions?.length>0 && this.actionType=='timedependent'){
            this.addTimeDependentInvoiceConvertAction(convertInvoice,this.conditionGroup[selectedCondtionIndex])
        }
    }

    addInvoiceConvertAction(recordDetails: WorkflowModelsNS.WorkflowAddEditActionConvertToInvoice, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        recordDetails.workflowActionId = addedCondition?.instantActions?.id||0;

        if(addedCondition?.instantActions?.workflowActionConvertToInvoices?.length>0){
            addedCondition.instantActions.workflowActionConvertToInvoices.unshift(recordDetails)
        }else{
            addedCondition.instantActions.workflowActionConvertToInvoices = [];
            addedCondition.instantActions.workflowActionConvertToInvoices.push(recordDetails);
            this.addNewActionOrder(addedCondition.instantActions,'workflowActionConvertToInvoices');
        }
    }

    addTimeDependentInvoiceConvertAction(recordDetails: WorkflowModelsNS.WorkflowAddEditActionConvertToInvoice, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        const workflowList = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionConvertToInvoices;
        recordDetails.workflowActionId = addedCondition.timeDependentActions[this.timeDependentIndex]?.id||0;

        if(workflowList?.length>0){
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionConvertToInvoices.unshift(recordDetails)
        }else{
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionConvertToInvoices = [];
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionConvertToInvoices.push(recordDetails);
            this.addNewActionOrder(addedCondition.timeDependentActions[this.timeDependentIndex],'workflowActionConvertToInvoices');
        }
    }

    removeInvoiceConvertAction(recordList: WorkflowModelsNS.WorkflowAddEditActionConvertToInvoice[], index: number, actionDetails: any){
        recordList.splice(index, 1);
        this.removeActionOrder(actionDetails,'workflowActionConvertToInvoices');
    }

    //Delete Records Action

    saveDeleteRecordsAction(){
        const selectedCondtionIndex = this.conditionGroup.findIndex(s=> s.id === this.conditionTemp.id);
        let recordDetails: WorkflowModelsNS.WorkflowAddEditActionDeleteRecords = {
            id: 0,
            workflowActionId: 0,
            objectId: this.workflowDetailsForm.getRawValue().selectedModule.objectId,
            objectName: this.workflowDetailsForm.getRawValue().selectedModule.name,
            changeStatus: this.selectedDeleteRecordStatus,
            statusId: Status.Active
        }

        if(selectedCondtionIndex>=0 && this.selectedActionDeleteRecord && this.selectedDeleteRecordIndex > -1){
            recordDetails = {
                ...this.selectedActionDeleteRecord,
                changeStatus: this.selectedDeleteRecordStatus
            }
            this.updateEditedDeletedRecord(recordDetails,this.conditionGroup[selectedCondtionIndex])
        }else{
            if(selectedCondtionIndex>=0 && this.actionType=='instant'){
                this.addDeleteRecordsAction(recordDetails,this.conditionGroup[selectedCondtionIndex])
            }else if(selectedCondtionIndex>=0 && this.conditionGroup[selectedCondtionIndex]?.timeDependentActions?.length>0 && this.actionType=='timedependent'){
                this.addTimeDependentDeleteRecordsAction(recordDetails,this.conditionGroup[selectedCondtionIndex])
            }
        }

        this.displayDeleteRecord = false;
    }

    updateEditedDeletedRecord(recordDetails: WorkflowModelsNS.WorkflowAddEditActionDeleteRecords, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        if(this.actionType=='instant'){
            if(addedCondition?.instantActions?.workflowActionDeleteRecords?.length > this.selectedDeleteRecordIndex){
                addedCondition.instantActions.workflowActionDeleteRecords[this.selectedDeleteRecordIndex] = recordDetails;
            }
        }else if(addedCondition.timeDependentActions?.length > this.timeDependentIndex){
            if(addedCondition.timeDependentActions[this.timeDependentIndex]?.workflowActionDeleteRecords?.length > this.selectedDeleteRecordIndex){
                addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionDeleteRecords[this.selectedDeleteRecordIndex] = recordDetails;
            }
        }

        this.selectedActionDeleteRecord = null;
        this.selectedDeleteRecordIndex = -1;
        this.timeDependentIndex = -1;
    }

    openDeleteRecordEdit(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1, recordDetails: WorkflowModelsNS.WorkflowAddEditActionDeleteRecords, index: number){
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;
        this.selectedActionDeleteRecord = ParseHelper.DeepCopy(recordDetails);
        this.selectedDeleteRecordStatus = recordDetails.changeStatus;
        this.selectedDeleteRecordIndex = index;
        this.displayDeleteRecord = true;
    }

    addDeleteRecordsAction(recordDetails: WorkflowModelsNS.WorkflowAddEditActionDeleteRecords, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){
        recordDetails.workflowActionId = addedCondition?.instantActions?.id||0;

        if(addedCondition?.instantActions?.workflowActionDeleteRecords?.length>0){
            addedCondition.instantActions.workflowActionDeleteRecords.unshift(recordDetails)
        }else{
            addedCondition.instantActions.workflowActionDeleteRecords = [];
            addedCondition.instantActions.workflowActionDeleteRecords.push(recordDetails);
            this.addNewActionOrder(addedCondition.instantActions,'workflowActionDeleteRecords');
        }
    }

    addTimeDependentDeleteRecordsAction(recordDetails: WorkflowModelsNS.WorkflowAddEditActionDeleteRecords, addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup){

        const workflowList = addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionDeleteRecords;
        recordDetails.workflowActionId = addedCondition.timeDependentActions[this.timeDependentIndex]?.id||0;

        if(workflowList?.length>0){
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionDeleteRecords.unshift(recordDetails)
        }else{
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionDeleteRecords = [];
            addedCondition.timeDependentActions[this.timeDependentIndex].workflowActionDeleteRecords.push(recordDetails);
            this.addNewActionOrder(addedCondition.timeDependentActions[this.timeDependentIndex],'workflowActionDeleteRecords');
        }
    }

    removeDeleteRecordAction(recordList: WorkflowModelsNS.WorkflowAddEditActionDeleteRecords[], index: number, actionDetails: any){
        recordList.splice(index, 1);
        this.removeActionOrder(actionDetails,'workflowActionDeleteRecords');
    }

    //Action Methods

    changeAction(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'instant'|'timedependent', timeDependentIndex: number = -1){

        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.actionType = type;
        this.timeDependentIndex = timeDependentIndex;

        if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.AddTask){
          this.selectedActionTask = null;
          this.displayAddTask = true;
        } else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.AddEmailAlert) {
            this.notificationType = WorkflowModelsNS.WorkflowNotificationTypeEnum.EMAIL;
            this.selectedActionEmail = null;
            this.displayAddEmailAlert = true;
        } else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.AddWhatsAppAlert) {
            this.notificationType = WorkflowModelsNS.WorkflowNotificationTypeEnum.WHATSAPP;
            this.selectedActionEmail = null;
            this.displayAddEmailAlert = true;
        } else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.UpdateField){
            this.selectedActionField = null;
            this.checkAddedUpdateField();
            this.displayUpdateField = true;
        } else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.AddSmsAlert){
            this.displayNewMsg = true;
        } else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.CreateRecord){
            this.selectedActionRecord = null;
            this.displayCreateRecord = true;
        } else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.UpdateRecord){
            this.selectedActionUpdateRecord = null;
            this.displayUpdateRecord = true;
        } else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.ConvertToInvoice){
            const conversionType = this.selectedAction?.code=='convertToSalesOrder' ? WorkflowModelsNS.WorkflowConversionTypeEnum.SalesOrder : WorkflowModelsNS.WorkflowConversionTypeEnum.Invoice;
            this.saveConvertAction(conversionType);
        } else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.Approval){
            this.selectedActionApprovals = [];
            this.displayAddApproval = true;
        } else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.DeleteRecord){
            this.selectedDeleteRecordStatus = Status.Deleted;
            this.selectedActionDeleteRecord = null;
            this.saveDeleteRecordsAction();
        }
         else if(this.selectedAction.id == WorkflowModelsNS.WorkflowActionTypeEnum.ItemReciept){
            const conversionType = WorkflowModelsNS.WorkflowConversionTypeEnum.PurchaseOrder;
            this.saveConvertAction(conversionType);
        }


        setTimeout(() =>{
            this.selectedAction = null;
        })
    }

    checkAddedUpdateField(fieldName: string = ""){
        const addedFields: string[] = [];
        if(this.actionType=='instant' && this.conditionTemp?.instantActions?.workflowActionUpdateFields?.length>0){
            this.conditionTemp.instantActions.workflowActionUpdateFields.filter(f=>f.statusId==Status.Active && (f.objectId==(this.selectedActionModule?.objectId||this.selectedModule?.objectId)) && f.fieldName!=fieldName).map(addedUpdatedFields=>{
                addedFields.push(addedUpdatedFields.fieldName);
            })
        }else{
            this.conditionTemp.timeDependentActions[this.timeDependentIndex]?.workflowActionUpdateFields?.filter(f=>f.statusId==Status.Active && (f.objectId==(this.selectedActionModule?.objectId||this.selectedModule?.objectId)) && f.fieldName!=fieldName).map(addedUpdatedFields=>{
                addedFields.push(addedUpdatedFields.fieldName);
            })
        }

        this.addedFields = addedFields;
    }


    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    closeDialog(){
        this.workflowAddEditDialog = "Add New Workflow";
        this.steperActiveIndex = 0;
        this.workflowEditId = 0;
        this.workflowDetails = null;
        this.workflowViewOnly = false;
        this.displayAddEditDialog = false;
        this.conditionGroup = [];

        const nameCtrl = this.workflowDetailsForm.get('name');
        nameCtrl.enable();

        this.initWorkflowDetailsForm();
        this.setSelectedUsers();
        this.dialogClosed.emit(true);
    }

    workflowExistValidator(): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {

            let enteredName: string = control.value?.trim();
            const oldName: string = (this.workflowDetails?.name && !this.workflowCopy) ? this.workflowDetails?.name : "";
            if(oldName==enteredName){
                return of(null);
            }

            return this.workflowService.getWorkflowByName(enteredName).pipe(
                map(res => {
                    return res && oldName !== enteredName ? { workflowExists: true } : null;
                })
            );
        };
    }

    //#region Task Scheduler

    checkWorkflowValidDate(){
        const nowDate = new Date().toISOString();
        this.workflowValidExpired = false;

        const fromdate = this.workflowDetails.validFromDate ? moment.utc(this.workflowDetails.validFromDate) : null;
        const todate = this.workflowDetails.validToDate ? moment.utc(this.workflowDetails.validToDate) : null;
        const nowdate =  moment.utc(nowDate);
        const fromDateValid: boolean = fromdate ? nowdate.diff(fromdate, 'seconds')>0 : true;
        const toDateValid: boolean = todate ? nowdate.diff(todate, 'seconds')<0 : true;

        if(!fromDateValid){
            this.workflowValidExpired = true;
            this.workflowValidExpiredText = 'Not Started';
        }

        if(!toDateValid){
            this.workflowValidExpired = true;
            this.workflowValidExpiredText = 'Expired';
        }
    }

    runNowWorkflowTaskScheduler() {
        this.confirmationService.confirm({
            message: 'In Time-Based Workflow, the workflow will be executed only once upon clicking.',
            header: 'Are you sure want to run this workflow?',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.taskSchedulerSubmitLoading = true;
                this.workflowService.runNowWorkflowScheduler(this.workflowDetails.id).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                    next: (response) => {
                        this.taskSchedulerSubmitLoading = false;
                        this.messageService.add({ severity: WorkflowMessages.success.toLowerCase(), summary: WorkflowMessages.success, detail: WorkflowMessages.taskRunNowSuccess });
                        this.closeDialog();
                    },
                    error: (error) => {
                        this.taskSchedulerSubmitLoading = false;
                        this.messageService.add({ severity: WorkflowMessages.error.toLowerCase(), summary: WorkflowMessages.error, detail: WorkflowMessages.taskRunningFailed });
                    }
                })
            },
            reject: () => {

            }
        });
    }

    getAllWarehouse() {
        this.savedSearchesService.getWarehouseFullList().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
            this.wareHouseLocationList = res?.length>0 ? res.filter(x=> x.statusId==1).map(x => ({ id: x.id, locationId: x.locationId, isDefault: x.isDefault, name: `${x?.locationId} - ${x.name}` })) : [];
        }, err => {
        });
    }

    //#endregion

    checkActions(actionDetails: any){
        return WorkflowModelsNS.WorkflowActionDefaultOrders.some(action=> actionDetails?.[action.code]?.length>0);
    }

    dropListAction(event: CdkDragDrop<any[]>, actionDetails: any) {
        let availableActions = event.container.data.filter(action=> actionDetails?.[action.code]?.length>0);
        moveItemInArray(availableActions, event.previousIndex, event.currentIndex);
        actionDetails.executionOrders = availableActions.concat(
            event.container.data.filter(item2 => !availableActions.some(item1 => item1.code === item2.code))
        );
        event.container.data = actionDetails.executionOrders;
        this.reOrderActions(actionDetails);
    }

    cdkDragStarted(actionDetails: any){
        actionDetails['hideContent'] = true;
    }

    cdkDragReleased(actionDetails: any){
        actionDetails['hideContent'] = false;
    }

    toggleActionList(action: any){
        action['collapsed'] = !action['collapsed'];
    }

    addNewActionOrder(actionDetails: any, actionCode: string){
        const lastOrder = (actionDetails.executionOrders.sort((a, b)=> b.executionOrder - a.executionOrder)?.[0]?.executionOrder||0);
        const actionOrderIndex = actionDetails.executionOrders.findIndex(action=> action.code==actionCode);
        actionDetails.executionOrders[actionOrderIndex].executionOrder = lastOrder + 1;
        actionDetails.executionOrders = actionDetails.executionOrders.sort((a, b)=> a.executionOrder - b.executionOrder);
        this.reOrderActions(actionDetails);
    }

    removeActionOrder(actionDetails: any, actionCode: string){
        if(actionDetails[actionCode]?.length==0){
            const actionOrderIndex = actionDetails.executionOrders.findIndex(action=> action.code==actionCode);
            actionDetails.executionOrders[actionOrderIndex].executionOrder = 0;
            actionDetails.executionOrders = actionDetails.executionOrders.sort((a, b)=> a.executionOrder - b.executionOrder);
            this.reOrderActions(actionDetails);
        }
    }

    reOrderActions(actionDetails: any){
        actionDetails.executionOrders.filter(action=> actionDetails[action.code]?.length>0).map((action, index)=>{
            action.executionOrder = index+1;
            actionDetails[action.code].map(actionList=>{
                actionList.executionOrder = action.executionOrder;
            });
        });

        actionDetails.executionOrders.filter(action=> actionDetails[action.code]?.length==0).map((action, index)=>{
            action.executionOrder = 0;
        });
    }

    updateRecordCount(recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecord){
        return recordDetails?.workflowCreateRecordProducts.filter(p=> p.statusId==Status.Active)?.length||0;
    }


    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

}
